<template>
  <div>
    <AppHeader style="margin-top: -20px;" title=" " />
      <div class="container">
    <div class="split80 left" style="padding-top: 70px;">
      <div class="row topnav" style="padding-left: 15px;">
        <div class="col-sm-11" style="margin-top: 20px;">
          <vue-barcode class="vue_barcode_ref" style="display: none;" v-if="currentOrderId != ''" :options="{ width: 3 }"
            :value="currentOrderId"></vue-barcode>
          <input autocomplete="one-time-code" type="text" ref="searchProduct" v-on:keyup.enter="getProduct(barcode)" v-model="barcode" id="Barcode"
            name="Barcode" placeholder="Enter Barcode Manually" style="border-radius: 10px;">
          <div v-show="showError" style="text-align:center">
            <label class="h3" style="color:cyan"> {{ this.mainErrorMsg }} </label>
          </div>
        </div>
      </div>

      <div>
        <div class="row table-wrap"
          style="color: #fff; padding-right: 15px;padding-left: 15px;padding-bottom: 0px;padding-top: 10px;background-color:var(--theme-bg-end);margin-top:0px;margin-left:5px;margin-right:5px;">
          <table class="table" style="color: #fff;margin-top: 0px;margin-bottom: 0px;">
            <tr>
              <td>
                <div class="grid-container-element" style="font-size: 21px;">
                  <div class="grid-child-element purple" style="text-align:right">{{ this.item_name }}</div>
                  <div class="grid-child-element green" style="text-align:right">{{ this.qty }}</div>
                  <div class="grid-child-element green" style="text-align:right">{{ this.unit_price }}</div>
                  <div class="grid-child-element green" style="text-align:right">{{ this.item_price }}</div>
                  <div class="grid-child-element green"></div>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="row table-wrap"
          style="color: #fff; padding-top: 0px;height: 300px;background-color:var(--theme-bg-end);margin-top:0px;margin-left:5px;margin-right:5px;">
          <table class="table" style="color: #fff;margin-top: 0px;padding-top:0px">
            <tr v-for="item in currentItem" :key="item.seqId">
              <td>
                <div class="grid-container-element" style="padding-bottom:4px;padding-top:4px">
                  <div class="grid-child-element purple" style="text-align:right;font-size: 19px;">{{ item.item_name }}
                  </div>
                  <div class="grid-child-element green" style="text-align:right;font-size: 19px;">
                    <input typ="text" style="width:50px;color: #000;font-size: 19px;"
                      v-on:keyup.enter="changCurrentItemQty()" @blur="changCurrentItemQty()" v-show="!setQty"
                      id="currentItemQty" v-model="currentItemQty" />
                    <div v-show="setQty" style="font-size: 19px">{{ (parseFloat(item.qty)).toFixed(3) }}</div>
                  </div>
                  <div class="grid-child-element green" style="text-align:right;font-size: 19px;">
                    {{ formatNumber(item.standard_rate) }}</div>
                  <div class="grid-child-element green" style="text-align:right;font-size: 19px;">
                    {{ formatNumber(item.price) }}</div>
                  <div class="grid-child-element green" style="text-align:right;font-size: 19px;"><a href="#"
                      @click="deleteOrderItem(item.item_code)" style="color:red;margin:2em;"><span
                        class="glyphicon glyphicon-minus"></span></a></div>
                </div>
              </td>
            </tr>
            <tr v-for="item in orderItems" :key="item.seqId">
              <td>
                <div class="grid-container-element" style="padding-bottom:4px;padding-top:4px">
                  <div class="grid-child-element purple" style="text-align:right;font-size: 19px;">{{ item.item_name }}
                  </div>
                  <div class="grid-child-element green" style="text-align:right;font-size: 19px;">
                    {{ parseFloat(item.qty).toFixed(3) }}</div>
                  <div class="grid-child-element green" style="text-align:right;font-size: 19px;">
                    {{ (parseFloat(item.standard_rate)).toFixed(2) }}</div>
                  <div class="grid-child-element green" style="text-align:right;font-size: 19px;">
                    {{ (parseFloat(item.price)).toFixed(2) }}</div>
                  <div class="grid-child-element green" style="text-align:right;font-size: 19px;"><a href="#"
                      @click="deleteOrderItem(item.item_code)" style="color:red"><span
                        class="glyphicon glyphicon-minus"></span></a></div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="row" style="padding: 15px; margin-top: 10px;">
        <div class="col-sm-4" style="width:100%;color:#000000; background-color: var(--theme-bg-end); min-height: 210px;">
          <div class="col-sm-4"
            style="position:fixed;width:250px;height:30px; min-height: 20px;left:0px;bottom:230px;margin-top: 0px;margin-bottom: 0px;margin-left : 0px;color:#000000; background-color: var(--theme-bg-end);margin-left: -15px;margin-right: -10px;">
            <a href="#" v-show="!setQty" @click="changCurrentItemQty()" style="color:green;"><span
                class="glyphicon glyphicon-ok" style="padding-bottom:20px;margin-left:80px"></span></a>
          </div>
          <div class="col-sm-4"
            style="position:fixed;width:250px;height:300px; min-height: 200px;left:0px;bottom:-80px;margin-top: 0px;margin-bottom: 0px;margin-left : 0px;color:#000000; background-color: var(--theme-bg-end);margin-left: -15px;margin-right: -10px;">
            <numericpad :onInput="onInput" :onDelete="onDelete" :onReset="onReset" :show="showKeypad" />
          </div>
        </div>

        <div class="col-sm-4"
          style="color:#ffffff;position:fixed;left:225px;bottom:40px;margin-bottom: -50px;margin-left : 0px;width:205px;height:230px;">
          <div class="row" style="background-color:var(--color4);margin-bottom: 0px; border-style: outset; height: 210px;border-radius: 10px;">
            <!-- <p style="font-size: 16px; font-weight: 700; text-align: center; color: #000000;margin: 0px 0px;">{{this.jsonData.payment_method}}</p> -->
            <div class="row" style="margin: 0px; padding: 0.2rem 0px;width:200px">
              <div class="col-sm-6" style="text-align: left; color: #000000;margin: 0px 0px; padding: 0px 0px;">
                <p style="font-weight: 700; padding-left: 5px; color:black; font-size:1em;">{{ this.jsonData.gift_card
                }}:
                </p>
              </div>
              <div class="col-sm-6" style="text-align: right; color: #000000;margin: 0px 0px;">
                <p style="font-weight: 700; color:black; font-size:0.85em ">{{ (formatNumber(this.balance || 0)) }}</p>
              </div>
            </div>
            <div class="row" style="margin: 0px; padding: 0.2rem 0px;width:200px">
              <div class="col-sm-6" style="text-align: left; color: #000000;margin: 0px 0px; padding: 0px 0px;">
                <p style="font-weight: 700; padding-left: 5px; color:black; font-size:1em;">{{ this.jsonData.cash }}:
                </p>
              </div>
              <div class="col-sm-6" style="text-align: right; color: #000000;margin: 0px 0px; ">
                <p style="font-weight: 700; color:black; font-size:0.85em;">{{ (formatNumber(this.cashAmount || 0)) }}
                </p>
              </div>
            </div>
            <div class="row" style="margin: 0px; padding: 0.2rem 0px;width:200px">
              <div class="col-sm-6" style="text-align: left; color: #000000;margin: 0px 0px; padding: 0px 0px;">
                <p style="font-weight: 700; padding-left: 5px; color:black; font-size:1em;">{{ this.jsonData.credit }}:
                </p>
              </div>
              <div class="col-sm-6" style="text-align: right; color: #000000;margin: 0px 0px;">
                <p style="font-weight: 700; color:black; font-size:0.85em;">{{ (formatNumber(this.creditAmount || 0))
                }}
                </p>
              </div>
            </div>
            <div class="row" style="margin: 0px; padding: 0.2rem 0px;width:200px">
              <div class="col-sm-6" style="text-align: left; color: #000000;margin: 0px 0px; padding: 0px 0px;">
                <p style="font-weight: 700; padding-left: 5px; color:black; font-size:1em;">
                  {{ this.jsonData.mobile_btn }}:</p>
              </div>
              <div class="col-sm-6" style="text-align: right; color: #000000;margin: 0px 0px;">
                <p style="font-weight: 700; color:black; font-size:0.85em;">{{ (formatNumber(this.mobileAmount || 0))
                }}
                </p>
              </div>
            </div>
            <div class="row" style="margin: 0px; padding: 0.2rem 0px;width:200px">
              <!--<div class="col-sm-6" style="text-align: left; color: #000000;"> <p style="font-size: 14px; font-weight: 700; padding-left: 15px;">Account:</p></div>-->
              <div class="col-sm-6" style="text-align: left; color: #000000;margin: 0px 0px; padding: 0px 0px;">
                <p style="font-weight: 700; padding-left: 5px; color:black; font-size:1em;">{{ this.jsonData.account }}:
                </p>
              </div>
              <div class="col-sm-6" style="text-align: right; color: #000000;margin: 0px 0px;">
                <p style="font-weight: 700; color:black; font-size:0.85em;">{{ (formatNumber(this.accountAmount || 0))
                }}
                </p>
              </div>
            </div>
            <div class="row" style="margin: 0px; padding: 0.2rem 0px;width:200px">
              <div class="col-sm-6" style="text-align: left; color: #000000;margin: 0px 0px; padding: 0px 0px;">
                <p style="font-weight: 700; padding-left: 5px; color:black; font-size:1em;">{{ this.jsonData.paid }}:
                </p>
              </div>
              <div class="col-sm-6" style="text-align: right; color: #000000;margin: 0px 0px;">
                <p style="font-weight: 700; color:black; font-size:0.85em;">{{ (formatNumber(this.paidAmount || 0)) }}
                </p>
              </div>
            </div>
            <div class="row" style="margin: 0px; padding: 0px;width:200px">
              <div class="col-sm-6" style="text-align: left; color: #000000;margin: 0px 0px; padding: 0px 0px;">
                <p style="font-weight: 700; padding-left: 5px; color:black; font-size:1em;">
                  {{ this.jsonData.outstanding }}:</p>
              </div>
              <div class="col-sm-6" style="text-align: right; color: #000000;margin: 0px 0px;">
                <p style="font-weight: 700; color:black; font-size:0.85em;">{{ (formatNumber(this.notPaidAmount || 0))
                }}
                </p>
              </div>
            </div>
            <div class="col-sm-4"
              style="color:#ffffff;position:fixed;left:640px;bottom:-20px;margin-bottom: 0px;margin-left : 0px;width:250px;height:230px;">
              <div v-show="showloyality"
                style="background-color: #CCCCCC;margin-top:0px;margin-bottom:0px;border-top: 1px solid #CCCCCC; border-right: 1px solid #333333; border-bottom: 1px solid #333333; border-left: 1px solid #CCCCCC;padding-top:5px;padding-left:10px">
                <h2
                  style="font-size: 16px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px;text-align:center">
                  {{ this.jsonData.loyalty_customer_info }}</h2>
                <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">
                  {{ this.jsonData.loyalty_name }}: {{ this.name }}</h3>
                <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">
                  {{ this.jsonData.loyalty_gender }}: {{ this.gender }}</h3>
                <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">
                  {{ this.jsonData.loyalty_email }}: {{ this.email }}</h3>
                <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">
                  {{ this.jsonData.loyalty_phone }}: {{ this.phone }}</h3>
                <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">
                  {{ this.jsonData.loyalty_total_points }}: {{ this.customerBalance }}</h3>
                <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">
                  {{ this.jsonData.loyalty_customer_since }}: {{ this.customersince }}</h3>
              </div>
              <!--          <div v-show="giftCardInfos" style="background-color: #FFFFFF;margin-top:10px;margin-bottom:10px;border-top: 1px solid #CCCCCC; border-right: 1px solid #333333; border-bottom: 1px solid #333333; border-left: 1px solid #CCCCCC;padding-top:5px;padding-left:10px">
             <h2 style="font-size: 16px; font-weight: bold;margin-top:10px;margin-bottom:10px">{{this.jsonData.gift_card_info}}:</h2>
             <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">{{this.jsonData.gift_card_number}}: {{this.giftcardnumber}}</h3>
             <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">{{this.jsonData.gift_card_name}}: {{this.giftcardname}}</h3>
             <h3 style="font-size: 14px;color:navy;font-weight: bold;margin-top:10px;margin-bottom:10px">{{this.jsonData.gift_card_balance}}: {{this.balance}}</h3>
           </div>
            -->

            </div>
          </div>
        </div>

        <!-- <div class="col-sm-4"
          style="padding-top:3px;background-color:var(--theme-bg-end);color:#ffffff;position:fixed;left:440px;bottom:-7px;margin-left : 0px;width:210px;height:230px;font-size:1.2em">
          <div class="row" style="margin-bottom: 40px; border-style: outset;height: 210px;">
            <div class="row" style="margin: 0px; width:210px;padding-top:0px;">
              <div class="col-sm-9" style="text-align: left; color: #ffffff;">
                <p style=" font-weight: 300; color:white; font-size:1.1em"><b>Items# :</b></p>
              </div>
              <div class="col-sm-3" style="text-align: right; color: #ffffff;">
                <p style=" font-weight: 300; color:white; font-size:1.1em">
                  {{ this.orderItems.length + this.currentItem.length }}</p>
              </div>
            </div>
            <div class="row" style="margin: 0px; width:210px;padding-top:10px;">
              <div class="col-sm-7" style="text-align: left; color: #ffffff;">
                <p style=" font-weight: 300;  color:white; font-size:1.1em">{{ this.jsonData.net_total }}:</p>
              </div>
              <div class="col-sm-5" style="text-align: right; color: #ffffff;">
                <p style=" font-weight: 300; color:white; font-size:1.1em">
                  {{ (parseFloat(this.netTotalAmount)).toFixed(2) }}</p>
              </div>
            </div>
            <div class="row" style="margin: 0px; padding: 0px;width:210px">
              <div class="col-sm-7" style="text-align: left; color: #ffffff;">
                <p style=" font-weight: 300;  color:white; font-size:1.1em">Vat (5%):</p>
              </div>
              <div class="col-sm-5" style="text-align: right; color: #ffffff;">
                <p style=" font-weight: 300; color:white; font-size:1.1em">{{ parseFloat(this.vatAmount).toFixed(2) }}</p>
              </div>
            </div>
            <div class="row" style="margin: 0px; padding: 0px;width:210px">
              <div class="col-sm-7" style="text-align: left; color: #ffffff;">
                <p style=" font-weight: 300;  color:white; font-size:1.1em">{{ this.jsonData.discount }}:</p>
              </div>
              <div class="col-sm-5" style="text-align: right; color: #ffffff;">
                <p style=" font-weight: 300; color:white; font-size:1.1em">
                  {{ (parseFloat(this.discountAmount)).toFixed(2) }}</p>
              </div>
            </div>
            <div class="row" style="margin: 0px; padding: 0px;width:210px">
              <div class="col-sm-7" style="text-align: left; color: #ffffff;">
                <p style=" font-weight: 300;  color:white; font-size:1.1em">Diff:</p>
              </div>
              <div class="col-sm-5" style="text-align: right; color: #ffffff;">
                <p style=" font-weight: 300; color:white; font-size:1.1em">{{ (parseFloat(this.diffAmount)).toFixed(2) }}
                </p>
              </div>
            </div>
            <div class="row" style="margin: 0px; padding: 0px; width:210px;">
              <div class="col-sm-7" style="text-align: left; color: #ffffff;">
                <p style="font-weight: 300;  color:white; font-size:1.1em">Grand:</p>
              </div>
              <div class="col-sm-5" style="text-align: right; color: #ffffff;">
                <p style=" font-weight: 300; color:white; font-size:1.1em">
                  {{ (parseFloat(this.grandTotalAmount)).toFixed(2) }}</p>
              </div>
            </div>
          </div>
        </div> -->

        <div class="col-sm-4"
          style="padding-top:3px;background-color:var(--theme-bg-end);color:#ffffff;position:fixed;left:440px;bottom:-7px;margin-left : 0px;width:210px;height:230px;font-size:1.2em;border-radius: 10px !important;">
          <div class="row" style="margin-bottom: 40px; border-style: outset;height: 210px;border-radius: 10px;">
            <div class="row" style="margin: 0px; width:210px;padding-top:0px;">
              <div class="col-sm-9" style="text-align: left; color: #ffffff;">
                <p style=" font-weight: 300; color:white; font-size:0.86em"><b>Items# :</b></p>
              </div>
              <div class="col-sm-3" style="text-align: right; color: #ffffff;">
                <p style=" font-weight: 300; color:white; font-size:0.86em">
                  {{ this.orderItems.length + this.currentItem.length }}</p>
              </div>
            </div>
            <div class="row" style="margin: 0px; width:210px;padding-top:10px;">
              <div class="col-sm-6" style="text-align: left; color: #ffffff;">
                <p style=" font-weight: 300;  color:white; font-size:0.86em">{{ this.jsonData.net_total }}:</p>
              </div>
              <div class="col-sm-6" style="text-align: right; color: #ffffff;">
                <p style=" font-weight: 300; color:white; font-size:0.86em">{{ (formatNumber(this.netTotalAmount)) }}</p>
              </div>
            </div>
            <div class="row" style="margin: 0px; padding: 0px;width:210px">
              <div class="col-sm-6" style="text-align: left; color: #ffffff;">
                <p style=" font-weight: 300;  color:white; font-size:0.86em">Vat:</p>
              </div>
              <div class="col-sm-6" style="text-align: right; color: #ffffff;">
                <p style=" font-weight: 300; color:white; font-size:0.86em">{{ formatNumber(this.vatAmount) }}</p>
              </div>
            </div>
            <!-- <div class="row" style="margin: 0px; padding: 0px;width:210px">
              <div class="col-sm-6" style="text-align: left; color: #ffffff;">
                <p style=" font-weight: 300;  color:white; font-size:0.86em">{{ this.jsonData.discount }}:</p>
              </div>
              <div class="col-sm-6" style="text-align: right; color: #ffffff;">
                <p style=" font-weight: 300; color:white; font-size:0.86em">{{ (formatNumber(this.discountAmount)) }}</p>
              </div>
            </div> -->
            <!-- <div class="row" style="margin: 0px; padding: 0px;width:210px">
              <div class="col-sm-6" style="text-align: left; color: #ffffff;">
                <p style=" font-weight: 300;  color:white; font-size:0.86em">Diff:</p>
              </div>
              <div class="col-sm-6" style="text-align: right; color: #ffffff;">
                <p style=" font-weight: 300; color:white; font-size:0.86em">{{ (formatNumber(this.diffAmount)) }}</p>
              </div>
            </div> -->
            <div class="row" style="margin: 0px; padding: 0px; width:210px;">
              <div class="col-sm-6" style="text-align: left; color: #ffffff;">
                <p style="font-weight: 300;  color:white; font-size:0.866em">G.T</p>
              </div>
              <div class="col-sm-6" style="text-align: right; color: #ffffff;">
                <p style=" font-weight: 300; color:white; font-size:0.86em">{{ (formatNumber(this.grandTotalAmount)) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="split20 right" style="padding-top:80px;overflow-y: hidden;">
        <div class="grid-container"  style="row-gap:0px;">
          <button v-if="hasPermission(5)" @click="handleSetQty" class="grid-item button"style="background-color: var(--color1);color: #fff"
><span>🔢</span> {{ this.jsonData.set_qunt_btn
          }}</button>
          <button v-if="hasPermission(6)" @click="handleCheckPrice" class="grid-item button"style="background-color: var(--color2);color: #fff"
          ><span>🔍</span> {{ this.jsonData.chk_price_btn }}</button>
          <button v-if="hasPermission(7)" @click="isLoyalityOpen = true" class="grid-item button"style="background-color: var(--color3);color: #fff"

          ><span>👤</span> {{ this.jsonData.loyalty_card_btn }}</button>
          <button v-if="hasPermission(8) && allowSync" @click="syncProducts()" class="grid-item button"style="background-color:#317185;color: #fff"
          ><span>🔄</span> Sync Products</button>

          <button v-if="hasPermission(9)" @click="clearPayments" class="grid-item button"style="background-color: #d6100e; color: #fff"

            ><span>🧹</span> {{ this.jsonData.clear_payments_btn }}</button>
          <button v-if="hasPermission(10)" @click="handleGiftCard" class="grid-item button"style="background-color: #6E79B6; color: #fff"
            ><span>🎁</span> {{ this.jsonData.gift_card_btn }}</button>
          <button v-if="hasPermission(11)" @click="startHandlingPayCash" class="grid-item button"  style="background-color: #594175; color: #fff"

            ><span>💵</span> {{ this.jsonData.cash_btn }}</button>
          <button v-if="hasPermission(12)" @click="startHandlingPayCredit" class="grid-item button"style="background-color: var(--color4); color: #fff"
            ><span>💳</span> {{ this.jsonData.card_btn }}</button>
          <button v-if="hasPermission(46)" @click="startHandlingPayMobile" class="grid-item button" style="background-color:#d48bb3; color: #fff"

            ><span>📱</span> {{ this.jsonData.mobile_btn }}</button>
          <button v-if="hasPermission(13)" @click="startHandlingPayAccount" class="grid-item button"style="background-color: var(--theme-accent);color: #fff"
          ><span>🧾</span> {{ this.jsonData.acc_btn }}</button>
        </div>
      </div>
    </div>
    <Loiality :open="isLoyalityOpen" :loyality="this.loyality" @getLoialityPoints="setLoialityPoints($event)"
      @close="isLoyalityOpen = !isLoyalityOpen" />
    <GiftCard :open="isGiftCardOpen" @getGiftCardInfos="setGiftCardInfos($event)"
      @close="isGiftCardOpen = !isGiftCardOpen" />
    <Void :open="isVoidOpen" @getPayReturnPermission="setPayReturnPermission($event)"
      @getVoidPermission="setVoidPermission($event)" @close="isVoidOpen = !isVoidOpen" />
    <CheckPrice :open="isCheckPriceOpen" :products="this.products" :msgItems="msgItems"
      @close="isCheckPriceOpen = !isCheckPriceOpen" />
    <NewProduct :open="isNewProductOpen" :products="this.products" :msgItems="msgItems"
      @getNewProductData="setNewProductData($event)" @close="isNewProductOpen = !isNewProductOpen" />
    <PayCash :cashAmount="Math.abs(parseFloat(notPaidAmount)).toFixed(2)" :pay_cash_close="pay_cash_close" :pay_cash_add_payment="pay_cash_add_payment"
      :pay_cash_cash_amount="pay_cash_cash_amount" :pay_cash_title="pay_cash_title" :open="isPayCashOpen"
      @getCashAmount="setCashAmount($event)" @close="isPayCashOpen = !isPayCashOpen" />
    <PayCredit :creditAmount="Math.abs(parseFloat(notPaidAmount)).toFixed(2)" :open="isPayCreditOpen"
      @getCreditAmount="setCreditAmount($event)" @close="isPayCreditOpen = !isPayCreditOpen" />
    <PayMobile :mobileAmount="Math.abs(parseFloat(notPaidAmount)).toFixed(2)" :open="isPayMobileOpen"
      @getMobileAmount="setMobileAmount($event)" @close="isPayMobileOpen = !isPayMobileOpen" />
    <PayAccount :accountAmount="Math.abs(parseFloat(notPaidAmount)).toFixed(2)" :open="isPayAccountOpen"
      @getCustomernumber="setCustomernumber($event)" @getCustomer="setCustomer($event)"
      @getCustomerName="setCustomerName($event)" @getAccountAmount="setAccountAmount($event)"
      @close="isPayAccountOpen = !isPayAccountOpen" />
    <CloseCash :open="isCloseCashOpen" @close="isCloseCashOpen = !isCloseCashOpen"
      @setCashDetail="closeUserCash($event)" />

    <ShowInfos :open="isShowInfosOpen" :popupMessage="popupMessage" :msgItems="msgItems"
      @close="isShowInfosOpen = !isShowInfosOpen" />
  </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import Loiality from "@/components/Loiality";
import GiftCard from "@/components/GiftCard";
import Void from "@/components/Void";
import CheckPrice from "@/components/CheckPrice";
import NewProduct from "@/components/NewProduct";
import PayCash from "@/components/PayCash";
import PayCredit from "@/components/PayCredit";
import PayMobile from "@/components/PayMobile";
import VueBarcode from '@chenfengyuan/vue-barcode';
import PayAccount from "@/components/PayAccount";
import CloseCash from "@/components/CloseCash";
import ShowInfos from "@/components/ShowInfos";
import numericpad from "@/components/SimpleKeyboard";
import { ref } from "vue"
import axios from "axios";
import commonServices from "@/shared/commonServices";
import MainMenu from "@/components/MainMenu";
import AppHeader from "@/components/AppHeader";


import router from '@/router';
const Swal = require('sweetalert2');
export default {
  mixins: [commonServices],
  mounted() {
    if (localStorage.reports_ok === "1") {
      this.reports_ok = true;
    }
    this.getTaxAmount();
    this.barcode = '';
    //if(localStorage.customerId !== undefined && localStorage.customerId != 0){
    //  this.getCustomerById(localStorage.customerId);
    //}
    if (localStorage.userId === undefined) {
      this.$router.push({ name: 'login' });
    }
    this.allowSync = localStorage.getItem('allow_sync') == 1;
    this.language = 'ar';
    this.handleLanguage();
    this.getHeaderFooter();
    this.getLogo();
    this.logoImage = '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';

    this.$el.querySelector('#Barcode').focus = true;

  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'font-family: "Catamaran", sans-serif;background-color: var(--theme-bg-end);')
  },

  components: { Loiality, GiftCard, Void, CheckPrice, PayCash, PayCredit, PayMobile, numericpad, PayAccount, CloseCash, ShowInfos, NewProduct, MainMenu, VueBarcode, AppHeader },
  data: function () {
    return {
      
      reports_ok: false,
      allowSync: false,
      popupMessage: '',
      msgItems: [],
      currencyValues: [],
      showError: false,
      logoImage: '',
      mainErrorMsg: '',
      customerId: 0,
      accCustomerid: 0,
      taxBaseAmount: 1.13,
      mobileAmount: 0,
      paymentProvider: "",
      logoUrl: '',
      changeAmount: 0,
      currentOrderId: '',
      isPrinted: false,
      isPaid: false,

      orderParkStatus: '',
      printOk: true,
      currentOrderDirty: false,
      languageName: '',
      item_name: '',
      item_price: '',
      unit_price: '',
      emptyAmount: '',
      pay_cash_title: '',
      pay_cash_cash_amount: '',
      pay_cash_add_payment: '',
      pay_cash_close: '',

      qty: '',
      orderHeader: {},
      paymentMethod: {},
      number: "",
      maxLength: 20,
      showKeypad: true,
      jsonData: {},
      language: 'en',
      filterdProducts: [],
      orderItems: [],
      promotions: [],
      currentItem: [],
      displayItems: [],
      barcode: '',
      seqId: 0,
      products: [],
      toggle: true,
      editedPrice: 0,
      editedRoderItem: [],
      authorizedToChangePrice: '',
      authorizedToPayReturn: '',
      cashPay: false,
      mobilePay: false,
      creditPay: false,
      accountPay: false,
      totalOrderAmount: 0,
      grandTotalAmount: 0,
      netTotalAmount: 0,
      diffAmount: 0,
      vatAmount: 0,
      notPaidAmount: 0,
      outstandingAmount: '',
      discountAmount: 0,
      paidAmount: 0,
      giftCardAmount: 0,
      prcision: 0,
      ordeCompleted: 'N',
      orderId: '',
      lastinvoicenumber: '',
      loyality: null,
      giftCardInfos: null,
      cashAmount: 0,
      creditAmount: 0,
      accountAmount: 0,
      customernumber: '',
      name: '',
      gender: '',
      email: '',
      phone: '',
      line1: '',
      line2: '',
      area: '',
      city: '',

      totalpoints: '',
      earnedpoints: 0,
      customerBalance: 0,
      dis_percentage: 0,
      prompMinimum_total: 0,
      promoDiscount: 0,
      customersince: '',
      balance: 0,
      giftcardname: '',
      giftcardnumber: '',
      cashPop: false,
      setQty: true,
      setPrice: true,
      currentItemQty: '',
      currentItemPrice: '',
      setQuantity: false,
      setCurrentPrice: false,
      parked: [],
      parkedSize: 0,
      discountRequested: [],
      delivery: [],
      discountRequestedSize: 0,
      discountRequestedSizeR: 0,
      deliverySize: 0,
      showDiscountRequested: false,
      showParked: false,
      showloyality: false,
      showChange: false,
      showDelivery: false,
      elem: '',
      customername: '',
      customer: 0,
      deleteItemIndex: -1,
      invoiceHeader: '',
      invoiceFooter: '',
    }
  },
  computed: {
    ...mapGetters({
      posData: 'posData',
      modules: "modules_options/modulesPers",
      userPermissions: "modules_options/userPermissions"
    }),
  },
  methods: {
    getHeaderFooter: async function () {
      try {
        let dataURL = this.apiURL + 'Orders/getInvoiceHeader';
        let logoJson = { "branchId": "1", "langId": "15" };
        let response = await axios.post(dataURL, logoJson);
        if (response.data.status === 'success') {
          this.invoiceHeader = response.data.results.header;
          this.invoiceFooter = response.data.results.footer;
        }
      }
      catch (error) {
        console.log(error);
      }
    },
    doSyncProducts: async function () {
      let alertSync = this.showInfo('Syncing...');
      try {
        console.log("Sync Done")

        let dataURL = this.apiURL + 'GiftCard/syncProducts';
        let response = await axios.post(dataURL, { "appId": localStorage.appId });
        if (response.data.status === 'success') {
          alertSync.close();
          Swal.fire(response.data.results + " Products Updated Successfully!", '', 'success')
        } else {
          alertSync.close();
          this.showAlert("Sync Failed Please Retry...")
        }

      }
      catch (error) {
        alertSync.close();
        this.showAlert("Sync Failed Please Retry...")
        console.log(error);
      }
    },
    syncProducts() {
      Swal.fire({
        title: 'Do you want to Sync Products?',
        icon: "question",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Sync Products',
        denyButtonText: `No`,
        confirmButtonColor: "#28a745",
        denyButtonColor: "#dc3545",
        cancelButtonColor: "#dc3545",
      }).then((result) => {
        if (result.isConfirmed) {
          this.doSyncProducts();
        } else if (result.isDenied) {
          Swal.fire('No Products Were Synchrinized', '', 'info')
        }
      })
    },
    getUnhandledOrders() {
      this.handleParked();
      this.toggle = false;
      this.showParked = false;
      this.showDiscountRequested = false;
    },
    printElem: function (elem) {
      var mywindow = window.open('', 'PRINT', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=0, top=0, width=10, height=10, visible=none, ');

      mywindow.document.write('<html><head><title>' + document.title + '</title><style>@page { size:auto; margin: 10px; }</style>');
      mywindow.document.write('</head><body onload="window.print(); window.close();" >');
      //mywindow.document.write('<h1>' + document.title  + '</h1>');
      mywindow.document.write(elem);
      mywindow.document.write('<br><br><br><br>');
      mywindow.document.write('</body></html>');
      mywindow.document.write('x1Fx1Bx1FxFFx49');
      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/
      mywindow.print();
      mywindow.close();

      return true;
    },

    printElemm: function (elem) {
      var mywindow = window.open('', 'PRINT', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=0, top=0, width=10, height=10, visible=none');
      mywindow.document.write('<html><head><title> Invoice </title><style>* {font-size: 12px;font-family: "Times New Romantd, th, tr, table { border-top: 1px solid black; border-collapse: collapse; } "; } td.description, th.description { width: 75px; max-width: 75px; } td.quantity, th.quantity { width: 40px; max-width: 40px; word-break: break-all; } td.price, th.price { width: 40px; max-width: 40px; word-break: break-all; } .centered { text-align: center; align-content: center; } .ticket { width: 155px; max-width: 155px; }</style>');
      mywindow.document.write('</head><body>');
      //mywindow.document.write('<img src="'+this.logoUrl+'" alt="Logo" width="100%"></img>');
      //viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">'+'<img src='+this.logoUrl+' width="100%" alt="Logo">'+'</td></tr></table>'; 

      //mywindow.document.write('<h1>' + document.title  + '</h1>');
      //newEle = newEle + this.invoiceHeader+elem+this.invoiceFooter;
      //newEle = newEle + elem;
      mywindow.document.write(elem);
      //mywindow.document.write('</body></html>');

      mywindow.document.write('<br><br></body></html>');
      mywindow.document.write('0x41/0x42');
      mywindow.document.write('0x00/0x30');

      //mywindow.document.close(); // necessary for IE >= 10
      //mywindow.focus(); // necessary for IE >= 10*/
      //const myTimeout = setTimeout("", 1000); 
      mywindow.print();
      mywindow.close();

      return true;
    },
    deleteOrderItem(id) {
      this.deleteItemIndex = id;
      this.isVoidOpen = true;
    },
    setPayReturnPermission(authorizedToPayReturn) {
      this.authorizedToPayReturn = authorizedToPayReturn;
      if (this.cashPay && this.authorizedToPayReturn === "Y") {
        this.handlePayCash();
      }
      if (this.creditPay && this.authorizedToPayReturn === "Y") {
        this.handlePayCredit();
      }
      if (this.accountPay && this.authorizedToPayReturn === "Y") {
        this.handlePayAccount();
      }
      if (this.mobilePay && this.authorizedToPayReturn === "Y") {
        this.handlePayMobile();
      }
      this.authorizedToPayReturn = "N";
    },

    deleteCurrentItem() {
      if (this.authorizedToChangePrice === 'Y') {
        this.currentItem = [];
        this.currentOrderDirty = true;
      } else {
        this.isVoidOpen = true;
      }
      if (this.orderItems.length === 0 && this.currentItem.length === 0) {
        this.currentOrderDirty = false;
      }
      this.authorizedToChangePrice = 'N'
    },

    handleScale() {
      this.$router.push({ name: 'scale' });
    },
    handFindbarcode() {
      this.$router.push({ name: 'findbarcode' });
    },

    handleAdmin() {
      this.$router.push({ name: 'admin' });
    },
    handleAddCustomer() {
      this.$router.push({ name: 'customers' });
    },
    handleReturns() {
      this.$router.push({ name: 'returns' });
    },

    handleParked: async function () {
      this.showError = false;
      this.mainErrorMsg = "";
      this.clearOrderState();
      this.getParked();
      if (this.parked.length > 0) {
        this.toggle = false;
        this.showParked = true;
        this.showDelivery = false;
        this.loyality = null;
        this.clearLoialityData();
        this.showDiscountRequested = false;
      }
    },
    getParked: async function () {
      try {
        let dataURL = this.apiURL + 'Orders/getOrderByStatus';
        let parkedJson = { "appId": localStorage.appId, 'status': '1' };
        let response = await axios.post(dataURL, parkedJson);
        if (response.data.status === 'success') {
          this.parked = response.data.results;

          this.parkedSize = this.parked.length;
        }
      }
      catch (error) {
        console.log(error);
      }
    },

    handleDeliveryOrders: async function () {
      this.showError = false;
      this.mainErrorMsg = "";
      this.getDelivery();

      this.toggle = false;
      this.showParked = false;
      this.showDiscountRequested = false;
      this.showDelivery = true;
      this.loyality = null;
      this.clearLoialityData();

      if (this.delivery.length > 0) {
        this.toggle = false;
        this.showParked = false;
        this.showDiscountRequested = false;
        this.showDelivery = true;


      }
    },
    getDelivery: async function () {
      try {

        let dataURL = this.apiURL + 'Orders/getOrderByStatus';
        let discountJson = { "appId": localStorage.appId, 'status': '3' };
        let response = await axios.post(dataURL, discountJson);
        if (response.data.status === 'success') {
          this.delivery = response.data.results;
          this.deliverySize = this.delivery.length;
        }
      }
      catch (error) {
        console.log(error);
      }
    },


    handleDiscountRequested: async function () {
      this.showError = false;
      this.mainErrorMsg = "";
      this.clearOrderState();
      this.getDiscountRequested();
      if (this.discountRequested.length > 0) {
        this.toggle = false;
        this.showParked = false;
        this.showDelivery = false;
        this.showDiscountRequested = true;
      }
    },
    getDiscountRequested: async function () {
      try {

        let dataURL = this.apiURL + 'Orders/getOrderByStatus';
        let discountJson = { "appId": localStorage.appId, 'status': '2' };
        let response = await axios.post(dataURL, discountJson);
        if (response.data.status === 'success') {
          this.discountRequested = response.data.results;
          this.discountRequestedSize = this.discountRequested.length;
          let discountRequestedR = [];
          for (var i = 0; i < this.discountRequested.length; i++) {
            if (this.discountRequested[i].discount > 0) {
              discountRequestedR.push(this.discountRequested[i]);
            }
          }
          this.discountRequestedSizeR = discountRequestedR.length;
        }
      }
      catch (error) {
        console.log(error);
      }
    },

    handleNewOrder() {
      this.showError = false;
      this.mainErrorMsg = "";
      this.clearOrderState();
      this.orderParkStatus = "";
      if (this.currentOrderDirty) {
      } else {
        this.orderItems = [];
        this.currentItem = [];
      }
      this.toggle = true;
      this.showParked = false;
      this.showDelivery = false;
      this.showDiscountRequested = false;
    },
    showAlert(msg) {
      Swal.fire({
        //position: 'middle',
        icon: 'error',
        title: msg,
        showConfirmButton: false,
        timer: 2000
        /*
        Swal.fire({
          title: this.jsonData.no_order_to_pay,
          icon: 'error',
          confirmButtonText: 'Cool'
        })
        */
        //this.$swal(this.jsonData.no_order_to_pay);
      })
    },
    startHandlingPayCash() {
      if (this.authorizedToPayReturn === "Y") {
        this.handlePayCash();
      } else {
        this.cashPay = true;
        this.creditPay = false;
        this.accountPay = false;
        this.mobilePay = false;
        this.isVoidOpen = true;
      }
    },
    startHandlingPayMobile() {
      if (this.authorizedToPayReturn === "Y") {
        this.handlePayMobile();
      } else {
        this.cashPay = false;
        this.creditPay = false;
        this.accountPay = false;
        this.mobilePay = true
        this.isVoidOpen = true;
      }
    },

    startHandlingPayCredit() {
      if (this.authorizedToPayReturn === "Y") {
        this.handlePayCredit();
      } else {
        this.cashPay = false;
        this.creditPay = true;
        this.accountPay = false;
        this.mobilePay = false;
        this.isVoidOpen = true;
      }
    },
    startHandlingPayAccount() {
      if (this.authorizedToPayReturn === "Y") {
        this.handlePayAccount();
      } else {
        this.cashPay = false;
        this.creditPay = false;
        this.accountPay = true;
        this.mobilePay = false;
        this.isVoidOpen = true;
      }
    },
    handlePayCash() {
      if (this.orderItems.length > 0 || this.currentItem.length > 0) {
        this.isPayCashOpen = true;
      } else {
        if (this.customerId != 0) {
          this.isPayCashOpen = true;
        } else {
          this.isPayCashOpen = false;
          this.showAlert(this.jsonData.no_order_to_pay);
        }
      }
      this.cashPay = false;
      this.creditPay = false;
      this.mobilePay = false;
      this.toggle = false;


    },
    handlePayCredit() {
      if (this.orderItems.length > 0 || this.currentItem.length > 0) {
        //this.outstandingAmount =parseFloat(this.notPaidAmount).toFixed(2);
        this.isPayCreditOpen = true;
      } else {
        if (this.customerId != 0) {
          this.isPayCreditOpen = true;

        } else {
          this.isPayCreditOpen = false;
          this.showAlert(this.jsonData.no_order_to_pay);
        } this.notPaidAmount = this.customerBalance;
      }
      /*
      if(this.orderItems.length > 0 || this.currentItem.length > 0){
        this.outstandingAmount =parseFloat(this.notPaidAmount).toFixed(2);
        this.isPayCreditOpen = true;
      }else{
        this.msgItems = [];
        this.msgItems.push({"id":"1", "cont":this.jsonData.no_order_to_pay});
        this.showAlert(this.jsonData.no_order_to_pay);
      }
      */
    },
    handlePayAccount() {
      if (this.orderItems.length > 0 || this.currentItem.length > 0) {
        //this.outstandingAmount =parseFloat(this.notPaidAmount).toFixed(2);
        this.isPayAccountOpen = true;
      } else {
        if (this.customerId != 0) {
          this.isPayAccountOpen = true;
        } else {
          this.isPayAccountOpen = false;
          this.showAlert(this.jsonData.no_order_to_pay);
        }
      }
      /*
            if(this.orderItems.length > 0 || this.currentItem.length > 0){
              this.isPayAccountOpen = true;
            }else{
              this.msgItems = [];
              this.msgItems.push({"id":"1", "cont":this.jsonData.no_order_to_pay});
              this.showAlert(this.jsonData.no_order_to_pay);
      
            }
      */
    },
    handleSetQty() {
      if (this.currentItem.length === 0) {
        this.msgItems = [];
        this.msgItems.push({ "id": "1", "cont": this.jsonData.no_currentItem });
        //this.isShowInfosOpen = true;      
        this.showAlert(this.jsonData.no_order_to_pay);

      } else {
        //this.$refs.searchProduct.unfocus();
        //this.$refs.currentItemQty.focus();
        this.$el.querySelector('#Barcode').focus = false;
        this.$el.querySelector('#currentItemQty').focus = true;
        this.setQty = false;
        this.setQuantity = true;
        this.currentItemQty = '';
      }
    },
    calcOrderVatTotal: function () {
      let orderVatAmount = 0;
      if (this.orderItems.length > 0) {
        let tax = this.taxBaseAmount;
        this.orderItems.forEach(function (order) {
          if(order.tax == 'Standard' || order.tax != 1){
            let newStandardRate = order.standard_rate / tax;
            let newPrice = newStandardRate * order.qty;
            let vatAmount = order.price - newPrice;
            orderVatAmount += Math.round(vatAmount)
          }
        });
      }
      if (this.currentItem.length > 0) {
        let tax = this.taxBaseAmount;
        this.currentItem.forEach(function (order) {
          if(order.tax == 'Standard' || order.tax != 1){
            let newStandardRate = order.standard_rate / tax;
            let newPrice = newStandardRate * order.qty;
            let vatAmount = order.price - newPrice;
            orderVatAmount += Math.round(vatAmount)
          }
        });
      }
      return orderVatAmount;
    },
    changCurrentItemQty() {
      if (parseFloat(this.currentItemQty).toFixed(3) === 0) {
      } else {
        if (parseFloat(this.currentItemQty).toFixed(3) < 0) {
          this.currentItem[0].qty = parseFloat(this.currentItemQty);
          this.currentItem[0].price = parseFloat(this.currentItemQty) * this.currentItem[0].standard_rate;
          this.currentItem[0].price_vat = parseFloat(this.currentItemQty) * this.currentItem[0].standard_rate;
          this.calcOrderTotalAmount();
        }
      }
      this.setQty = true;
      this.setQuantity = false;

    },
    onInput(key) {
      if (key == 11) {
        if (this.setQuantity) {
          this.currentItemQty = (this.currentItemQty + '0').slice(0, this.maxLength);
        } else {
          this.barcode = (this.barcode + '0').slice(0, this.maxLength);
        }
      } else {
        if (this.setQuantity) {
          this.currentItemQty = (this.currentItemQty + key).slice(0, this.maxLength);
        } else {
          this.barcode = (this.barcode + key).slice(0, this.maxLength);
        }
      }
      //this.getProduct(this.barcode);

    },
    onDelete() {
      if (this.setCurrentPrice) {

        this.currentItemPrice = (this.currentItemPrice + key).slice(0, this.maxLength);
      } else {
        if (this.setQuantity) {
          this.currentItemQty = (this.currentItemQty + key).slice(0, this.maxLength);
        } else {
          this.barcode = this.barcode.slice(0, this.barcode.length - 1);
        }
      }
    },
    onReset() {
      if (this.setCurrentPrice) {
        this.currentItemPrice = "";
      } else {
        if (this.setQuantity) {
          this.currentItemQty = "";
        } else {
          this.barcode = "";
        }
      }
    },
    setVoidPermission(authorizedToChangePrice) {
      if ((this.orderItems.length !== 0 || this.currentItem.length !== 0) && this.deleteItemIndex !== -1) {

        this.authorizedToChangePrice = authorizedToChangePrice;
        let notfound = true;
        if (this.authorizedToChangePrice === 'Y') {
          for (var i = 0; i < this.orderItems.length; i++) {
            if (this.orderItems[i].item_code === this.deleteItemIndex) {
              notfound = false;
              this.orderItems.splice(i, 1);
              this.currentOrderDirty = true;
            }
          }
          if (notfound) {
            if (this.currentItem[0].item_code === this.deleteItemIndex) {
              this.currentItem = [];
              this.currentOrderDirty = true;
            }
          }
          this.calcOrderTotalAmount();
        } else {
          // Error message mo permission
        }

        if (this.orderItems.length === 0 && this.currentItem.length === 0) {
          this.currentOrderDirty = false;
        }
        this.authorizedToChangePrice = 'N'
        this.deleteItemIndex = -1;

      }
    },

    handleNewProduct() {
      this.isNewProductOpen = true
      this.msgItems = [];
      this.msgItems.push({ "id": "1", "cont": this.jsonData.enter_barcode_or_name });

    },

    handleCloseCash: async function () {

      this.isCloseCashOpen = true;

    },
    handleDailyTotals() {
      this.$router.push({ name: 'dailytotal' });
    },

    handleItemsDaily() {
      this.$router.push({ name: 'itemsdaily' });
    },
    handleReports() {
      this.$router.push({ name: 'reports' });
    },
    handlePayMobile() {
      if (this.orderItems.length > 0 || this.currentItem.length > 0) {
        //this.outstandingAmount =parseFloat(this.notPaidAmount).toFixed(2);
        this.isPayMobileOpen = true;
      } else {
        if (this.customerId != 0) {
          this.isPayMobileOpen = true;

        } else {
          this.isPayMobileOpen = false;
          this.showAlert(this.jsonData.no_order_to_pay);
        } this.notPaidAmount = this.customerBalance;
      }
    },

    handleCheckPrice() {
      this.isCheckPriceOpen = true
      this.msgItems = [];
      this.msgItems.push({ "id": "1", "cont": this.jsonData.enter_barcode_or_name });
    },

    handleGiftCard() {
      if (this.orderItems.length > 0 || this.currentItem.length > 0) {
        //this.outstandingAmount =parseFloat(this.notPaidAmount).toFixed(2);
        this.isGiftCardOpen = true;
      } else {
        if (this.customerId != 0) {
          this.isGiftCardOpen = true;
        } else {
          this.isGiftCardOpen = false;
          this.showAlert(this.jsonData.no_order_to_pay);
        }
      }
      /*
            if(this.orderItems.length>0 || this.currentItem.length>0){
              this.cashPop = true;
              this.isGiftCardOpen = true;
            }else{
              this.msgItems = [];
              this.msgItems.push({"id":"1", "cont":this.jsonData.no_order_to_pay});
              //this.isShowInfosOpen = true;
              this.showAlert(this.jsonData.no_order_to_pay);
            }
      */
    },

    clearPayments: function () {
      this.cashAmount = 0;
      this.creditAmount = 0;
      this.accountAmount = 0;
      this.mobileAmount = 0;
      this.paidAmount = 0;
      this.balance = 0;
      this.discountAmount = 0;
      this.calcOrderTotalAmount();
      this.notPaidAmount = parseFloat(this.grandTotalAmount) - parseFloat(this.cashAmount) - parseFloat(this.creditAmount) - parseFloat(this.balance) - parseFloat(this.accountAmount) - parseFloat(this.discountAmount);
      this.outstandingAmount = this.notPaidAmount;
    },
    goLogin() {
      this.$router.push({ name: 'login' });
    },
    handleFindInvoice() {
      this.$router.push({ name: 'find' });
    },

    requestDiscount1: async function () {
      try {
        //Order Payment API
        //const paymentDetails = [{"paymenttype":"cash", "amount":this.totalAmount, "accountid":"0"}, {"paymenttype":"credit", "amount":this.creditAmount, "accountid":"0"}, {"paymenttype":"account", "amount":this.accountAmount, "accountid":"0"}];
        let dataURL = this.apiURL + 'Orders/payOrder';
        let loginJson = { "appId": localStorage.appId, 'orderId': this.orderId, "paymentDetails": [] };

        let response = await axios.post(dataURL, loginJson);
        if (response.data.status === 'success') {
          console.log("Not saved");
        }
      }
      catch (error) {
        console.log(error);
      }
      this.close();
    },
    calcPaid() {
      this.paidAmount = 0;

      if (parseFloat(this.cashAmount) < 0) {
        this.paidAmount = parseFloat(this.paidAmount) + parseFloat(this.cashAmount);
      }
      if (parseFloat(this.creditAmount) < 0) {
        this.paidAmount = parseFloat(this.paidAmount) + parseFloat(this.creditAmount);
      }
      if (parseFloat(this.mobileAmount) < 0) {
        this.paidAmount = parseFloat(this.paidAmount) + parseFloat(this.mobileAmount);
      }
      if (parseFloat(this.balance) < 0) {
        this.paidAmount = parseFloat(this.paidAmount) + parseFloat(this.balance);
      }
      if (parseFloat(this.accountAmount) < 0) {
        this.paidAmount = parseFloat(this.paidAmount) + parseFloat(this.accountAmount);
      }
      this.notPaidAmount = parseFloat(this.grandTotalAmount) - parseFloat(this.paidAmount);
      this.msgItems = [];
      this.msgItems.push({ "id": "1", "cont": this.jsonData.cahange });

      this.msgItems.push({ "id": "1", "cont": (1 * (parseFloat(this.notPaidAmount).toFixed(2))) });
      let notPaid = this.notPaidAmount;
      this.outstandingAmount = Math.round(notPaid * 100) / 100;
      if (notPaid > 0) {
        notPaid = -1 * notPaid;
      }
      //console.log("notPaid", Math.round(notPaid*100)/100)

      if (this.notPaidAmount > 0 && Math.round(notPaid * 100) / 100 !== 0) {
        this.isShowInfosOpen = true;
      }
      //}
    },

    fixNumber(num) {
      let mum2 = parseFloat(Math.round(num)).toFixed(2);
      return mum2;
    },
    getImgUrl() {
      let logoUrlStr;
      logoUrlStr = this.logoUrl;
      return logoUrlStr;
    },
    getCurrentDateTime() {
      let dateTimeStr = '';
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      var today = new Date();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      dateTimeStr = year + '-' + month + '-' + day + ' ' + time;
      return dateTimeStr;
    },
    startOrderProcessing(status) {
      this.processOrder('0');
    },
    printUgandaOrder() {
      this.isPrinted = false;
      let barcodeCanvas = document.querySelector('.vue_barcode_ref');
      let barcodeImageSrc = barcodeCanvas.toDataURL();
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.toLocaleString('en-us', { month: 'short' });
      let day = nowDate.getDate();
      var today = new Date();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      let rows = ``
      let self = this;
      let formatNumber = this.formatNumber;
      let quantity = 0
      this.currentItem.forEach(function (order) {
        quantity -= order.qty
        rows += `<tr>
              <td colspan="5">${order.item_name}</td>
            </tr>
            <tr>
              <td style="text-align:center"></td>
              <td style="text-align:center">${parseFloat(order.qty).toFixed(3)}</td>
              <td style="text-align:center">${order.uom ?? 'PCS'}</td>
              <td style="text-align:center">${formatNumber(order.standard_rate)}</td>
              <td style="text-align:center">${formatNumber(order.price)}</td>
            </tr>`
      });
      this.orderItems.forEach(function (order) {
        quantity -= order.qty
        rows += `<tr>
              <td colspan="5">${order.item_name}</td>
            </tr>
            <tr>
              <td style="text-align:center"></td>
              <td style="text-align:center">${parseFloat(order.qty).toFixed(3)}</td>
              <td style="text-align:center">${order.uom ?? 'PCS'}</td>
              <td style="text-align:center">${formatNumber(order.standard_rate)}</td>
              <td style="text-align:center">${formatNumber(order.price)}</td>
            </tr>`
      });
      let payments = ``;
      let payTotal = 0
      if (Math.round(parseFloat(this.discountAmount) * 100) / 100 > 0) {
        payTotal -= this.discountAmount;
        payments += `<tr>
              <td colspan="4">Discount</td>
              <td style="text-align:center">-${(this.formatNumber(this.discountAmount))}</td>
            </tr>`
      }

      if (Math.round(parseFloat(this.cashAmount) * 100) / 100 > 0) {
        payTotal -= this.cashAmount;
        payments += `<tr>
              <td colspan="4">Cash</td>
              <td style="text-align:center">${(this.formatNumber(this.cashAmount))}</td>
            </tr>`
      }

      if (Math.round(parseFloat(this.creditAmount) * 100) / 100 > 0) {
        payTotal -= this.creditAmount;
        payments += `<tr>
              <td colspan="4">Credit</td>
              <td style="text-align:center">${(this.formatNumber(this.creditAmount))}</td>
            </tr>`
      }

      if (Math.round(parseFloat(this.mobileAmount) * 100) / 100 > 0) {
        payTotal -= this.mobileAmount;
        payments += `<tr>
              <td colspan="4">${this.paymentProvider}</td>
              <td style="text-align:center">${(this.formatNumber(this.mobileAmount))}</td>
            </tr>`
      }

      if (Math.round(parseFloat(this.accountAmount) * 100) / 100 > 0) {
        payTotal -= this.accountAmount;
        payments += `<tr>
              <td colspan="4">Account</td>
              <td style="text-align:center">${(this.formatNumber(this.accountAmount))}</td>
            </tr>`
      }
      if (this.balance > 0) {
        payments += `<tr>
              <td colspan="4">Balance</td>
              <td style="text-align:center">${(this.formatNumber(this.balance))}</td>
            </tr>`
      }
      else {
        if (this.balance !== 0) {
          `<tr>
              <td colspan="4">Balance</td>
              <td style="text-align:center">${(this.formatNumber(this.balance))}</td>
            </tr>`
        }
      }
      let changeTotal = this.paidAmount - this.grandTotalAmount;
      if (changeTotal < 0) {
        changeTotal = `<tr>
              <td colspan="4">Change</td>
              <td style="text-align:center">${(this.formatNumber(Math.abs(changeTotal)))}</td>
            </tr>`
      } else {
        changeTotal = ``
      }
      let customerPoints = '';
      if(this.loyality != null){
        customerPoints += `
        <div style="display:flex;justify-content: space-between;padding: .5rem 0.2rem;">
          <p>Points From This Sale:</p>
         <p> ${this.earnedpoints} </p>
        </div>
        <div style="display:flex;justify-content: space-between;padding: .5rem 0.2rem;">
          <p>Total Points:</p>
         <p> ${this.totalpoints-this.earnedpoints} </p>
        </div>
        
        `
      }
      let elem = `
    ${this.invoiceHeader}
    <div style="display: flex; justify-content: center;flex-direction:column">
      
      
        <table>
          <thead>
            <th
              style="
                border-bottom: 1px dashed;
                padding: .5rem 0;
              "
              col="2"
            >
              Item
            </th>
            <th
              style="
                border-bottom: 1px dashed;
                padding: .5rem 0;
              "
            >
              Qty
            </th>
            <th
              style="
                border-bottom: 1px dashed;
                padding: .5rem 0;
              "
            >
              Unit
            </th>
            <th
              style="
                border-bottom: 1px dashed;
                padding: .5rem 0;
              "
            >
              Price
            </th>
            <th
              style="
                border-bottom: 1px dashed;
                padding: .5rem 0;
              "
            >
              Amount
            </th>
          </thead>
          <tbody>
            ${rows}
            <tr style="height: 15px;">
              <td colspan="5"></td>
            </tr>
            <tr>
              <td colspan="6" style="border-bottom: 1px dashed;text-align:center;font-weight: bolder;font-size: 1rem !important;padding-bottom: .8rem;">${this.orderItems.length + this.currentItem.length} Items Sold</td>
            </tr>
            <tr style="font-weight: 1000;">
              <td style="font-size: 1.1.rem !important;" colspan="4">Total</td>
              <td style="font-size: 1.1.rem !important;text-align:center">${this.formatNumber(this.grandTotalAmount)}</td>
            </tr>
            ${payments}
            <tr>
                <td style="border-bottom: 1px dashed; padding-bottom: .5rem" colspan="6"></td>
            </tr>
            <tr>
              <td style="padding-top:.5rem;" colspan="4">Tendered Total</td>
              <td style="padding-top:.5rem;text-align:center">${this.formatNumber(this.paidAmount)}</td>
            </tr>
            ${changeTotal}
            <tr>
                <td style="border-bottom: 1px dashed; padding-bottom: .5rem" colspan="6"></td>
            </tr>
           
          </tbody>
        </table>
        <div style="display:flex;justify-content: space-between;padding: .5rem 0.2rem;">
          <p>Customer Name:</p>
         <p> ${this.loyality != null || this.phone !== "" ? this.name : 'Cash Customer'} </p>
        </div>
        ${customerPoints}
        <div style="display: flex; justify-content: center">
          <img style="width:65%"
            src="${barcodeImageSrc}"
          />
        </div>

        <table style="margin-bottom: 1rem;">
            <thead>
              <th
                style="padding: .5rem 0;"
                col="2"
              >
                Date
              </th>
              <th
                style="padding: .5rem 0;"
              >
                Time
              </th>
              <th
                style="padding: .5rem 0;"
              >
                Served By
              </th>
              
            </thead>
            <tbody>
              <tr>
                <td style="border-bottom: 1px dashed;border-top:1px dashed;padding: .8rem ;text-align:center">${day} ${month} ${year}</td>
                <td style="border-bottom: 1px dashed;border-top:1px dashed;padding: .8rem ;text-align:center">${time}</td>
                <td style="border-bottom: 1px dashed;border-top:1px dashed;padding: .8rem ;text-align:center">${localStorage.username}</td>
              </tr>

            
            </tbody>
          </table>
          ${this.invoiceFooter}
      `

      var mywindow = window.open('', 'PRINT', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=0, top=0, width=10, height=10, visible=none');

      //mywindow.document.write('<img src="'+this.logoUrl+'" alt="Logo" width="100%"></img>');
      //viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">'+'<img src='+this.logoUrl+' width="100%" alt="Logo">'+'</td></tr></table>'; 

      //mywindow.document.write('<h1>' + document.title  + '</h1>');
      //newEle = newEle + this.invoiceHeader+elem+this.invoiceFooter;
      //newEle = newEle + elem;
      mywindow.document.write(elem);


      //mywindow.document.close(); // necessary for IE >= 10
      //mywindow.focus(); // necessary for IE >= 10*/
      //const myTimeout = setTimeout("", 1000); 
      setTimeout(function () { mywindow.print(); mywindow.close(); }, 300);
      this.isPrinted = true;
      return true;
    },
    printOrder() {
      this.isPrinted = false;

      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      var today = new Date();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      let viaInvStr = '<p><img width=\"100%\" alt=\"Logo\" src=\"'+ this.baseUrl +'uploads/appLogo20220804103749.png\"></img></p>';
      viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">' + this.invoiceHeader + '</td></tr>';



      viaInvStr = viaInvStr + '<tr><td align="left" width="100%">Order: <b>' + this.currentOrderId + '</b>     <b>' + this.orderHeader.orderDate + '</b></td></tr>';
      viaInvStr = viaInvStr + '<tr><td align="left" width="100%">Casheir: ' + localStorage.username + '</td></tr>';
      viaInvStr = viaInvStr + '</table>';
      viaInvStr = viaInvStr + '<table align="center" width="100%" style="border-top: #000000 1px solid;border-bottom: #000000 1px solid;"><tr>';
      viaInvStr = viaInvStr + '<td colspan=3 align="center"><b>Item</b></td>';
      viaInvStr = viaInvStr + '<td width="33%" align="center"><b>Qty</b></td>';
      viaInvStr = viaInvStr + '<td width="33%" align="center"><b>Unit</b></td>';
      viaInvStr = viaInvStr + '<td width="34%" align="center"><b>Total</b></td></tr>';
      viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
      this.orderItems.forEach(function (order) {
        viaInvStr = viaInvStr + '<tr><td colspan=3 align="left">' + order.item_name + '</td><td width="33%" align="center">' + parseFloat(order.qty).toFixed(3) + '</td><td width="33%" align="center">' + (parseFloat(order.standard_rate)).toFixed(2) + '</td><td width="33%" align="right">' + (parseFloat(order.price)).toFixed(2) + '</td></tr>';
        //viaInvStr = viaInvStr + '<tr><td colspan=3 align="left">'+order.item_name+'</td><td width="33%" align="center">'+parseFloat(order.qty).toFixed(3)+'</td><td width="33%" align="center">'+(parseFloat(order.standard_rate)).toFixed(2)+'</td><td width="33%" align="right">'+(parseFloat(order.standard_rate) * parseFloat(order.qty)).toFixed(2)+'</td></tr>';
      });
      this.currentItem.forEach(function (order) {
        viaInvStr = viaInvStr + '<tr><td colspan=3 align="left">' + order.item_name + '</td><td width="33%" align="center">' + parseFloat(order.qty).toFixed(3) + '</td><td width="33%" align="center">' + (parseFloat(order.standard_rate)).toFixed(2) + '</td><td width="33%" align="right">' + (parseFloat(order.price)).toFixed(2) + '</td></tr>';
      });
      viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
      viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Net Total</b></td><td width="50%" align="right" colspan=3><b>' + parseFloat(this.netTotalAmount).toFixed(2) + '</b></td></tr>';
      if (Math.round(parseFloat(this.discountAmount) * 100) / 100 > 0) {
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Discount</b></td><td width="50%" align="right" colspan=3><b>' + parseFloat(this.discountAmount).toFixed(2) + '</b></td></tr>';
      }

      viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>VAT</b></td><td width="50%" align="right" colspan=3><b>' + parseFloat(this.vatAmount).toFixed(2) + '</b></td></tr>';
      if (Math.round(parseFloat(this.diffAmount) * 100) / 100 > 0) {
        //if(parseFloat(this.diffAmount).toFixed(2) !== 0){
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Diff</b></td><td width="50%" align="right" colspan=3><b>' + parseFloat(this.diffAmount).toFixed(2) + '</b></td></tr>';
      }
      viaInvStr = viaInvStr + '<tr style="font-size: 24px;"><td width="50%" align="left"colspan=3><b>Grand Total</b></td><td width="50%" align="right" colspan=3><b>' + parseFloat(this.grandTotalAmount).toFixed(2) + '</b></td></tr>';
      viaInvStr = viaInvStr + '<tr><td width="100%" align="left" colspan="3">Paid:</td></tr>';

      if (this.cashAmount > 0) {
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan="3">   Cash:</td><td width="50%" align="right" >' + (parseFloat(this.cashAmount)).toFixed(2) + '</td></tr>';
      } else {
        if (this.cashAmount !== 0) {
          viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan="3">   Cash:</td><td width="25%" align="right" >' + (-1 * parseFloat(this.cashAmount)).toFixed(2) + '</td></tr>';
        }
      }
      if (this.creditAmount > 0) {
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan="3">   Credit Card: </td><td width="33%" align="right" >' + (parseFloat(this.creditAmount)).toFixed(2) + '</td></tr>';
      } else {
        if (this.creditAmount !== 0) {
          viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan="3">   Credit Card: </td><td width="33%" align="right" >' + (-1 * parseFloat(this.creditAmount)).toFixed(2) + '</td></tr>';
        }

      }
      if (this.accountAmount > 0) {
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan="3">   Account: </td><td width="33%" align="right" >' + (parseFloat(this.accountAmount)).toFixed(2) + '</td></tr>';
      } else {
        if (this.accountAmount !== 0) {
          viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan="3">   Account: </td><td width="33%" align="right" >' + (-1 * parseFloat(this.accountAmount)).toFixed(2) + '</td></tr>';
        }

      }
      if (this.balance > 0) {
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan="3">   Gift Card:</td><td width="33%" align="right" >' + (parseFloat(this.balance)).toFixed(2) + '</td></tr>';
      } else {
        if (this.balance !== 0) {
          viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan="3">  Gift Card:</td><td width="33%" align="right" >' + (-1 * parseFloat(this.balance)).toFixed(2) + '</td></tr>';
        }

      }
      if (this.grandTotalAmount === 0) {
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Change:</b></td><td width="50%" align="right" colspan=3><b>' + (parseFloat(-1 * this.notPaidAmount).toFixed(2)) + '</b></td></tr>';
      } else {
        if ((Math.round(parseFloat(this.notPaidAmount).toFixed(2) * 100) / 100) !== 0) {
          viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Change:</b></td><td width="50%" align="right" colspan=3><b>' + (parseFloat(-1 * this.notPaidAmount).toFixed(2)) + '</b></td></tr>';

        }
        /*
        if(this.notPaidAmount!=0){
          viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Change</b></td><td width="50%" align="right" colspan=3><b>'+(-1*parseFloat(this.notPaidAmount).toFixed(2))+'</b></td></tr>';

        }
        */
      }

      if (this.loyality !== null || this.name !== "") {
        viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Customer name: </td><td align="left" width="33%" align="right" ><b>' + this.name + '</b></td><td width="33%" align="right" ></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Phone: </td><td align="left" width="33%" align="right" ><b>' + this.phone + '</b></td><td width="33%" align="right" ></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Address line 1: </td><td align="left" width="33%" align="right" ><b>' + this.line1 + '</b></td><td width="33%" align="right" ></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Address line 2: </td><td align="left" width="33%" align="right" >:<b>' + this.line2 + '</b></td><td width="33%" align="right" ></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Area: </td><td align="left" width="33%" align="right" ><b>' + this.area + '</b></td><td width="33%" align="right" ></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> City: </td><td align="left" width="33%" align="right" ><b>' + this.city + '</b></td><td width="33%" align="right" ></td></tr>';
      }
      viaInvStr = viaInvStr + '</table>';
      viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">' + this.invoiceFooter + '</td></tr></table>';
      viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td>Printed on: ' + day + "/" + month + "/" + year + ' :' + time + '</td></tr></table>';
      viaInvStr = viaInvStr + '<br><div><img align="center" width=\"100%\" alt=\"Logo\" src=\"'+ this.baseUrl +'uploads/tnsfooter.gif\"></img></div>';
      viaInvStr = viaInvStr + '<br><div style="font-size=8; text-align:center">Powered by UNiFi Middle East</div>';
      this.printElemm(viaInvStr);
      this.isPrinted = true;
    },

    startDeliveryOrderProcessing() {
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      var today = new Date();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      let viaInvStr = '';
      viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">' + this.invoiceHeader + '</td></tr>';
      viaInvStr = viaInvStr + '<tr><td>Order : ' + this.currentOrderId + ' Order\'s Date : ' + day + "/" + month + "/" + year + '<br></td></tr>';
      viaInvStr = viaInvStr + '<tr><td>Casheir : ' + localStorage.username + '<br></td></tr></table>';
      viaInvStr = viaInvStr + '<table align="center" width="100%" style="border-top: #000000 1px solid;border-bottom: #000000 1px solid;"><tr>';
      viaInvStr = viaInvStr + '<td colspan=3 align="center"><b>Item</b></td>';
      viaInvStr = viaInvStr + '<td width="33%" align="center"><b>Qty</b></td>';
      viaInvStr = viaInvStr + '<td width="33%" align="center"><b>Unit</b></td>';
      viaInvStr = viaInvStr + '<td width="34%" align="center"><b>Total</b></td></tr>';
      viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
      this.orderItems.forEach(function (order) {
        viaInvStr = viaInvStr + '<tr><td colspan=3 align="left">' + order.item_name + '</td><td width="33%" align="center">' + order.qty + '</td><td width="33%" align="center">' + (parseFloat(order.standard_rate)).toFixed(2) + '</td><td width="33%" align="right">' + (parseFloat(order.price)).toFixed(2) + '</td></tr>';
      });
      this.currentItem.forEach(function (order) {
        viaInvStr = viaInvStr + '<tr><td colspan=3 align="left">' + order.item_name + '</td><td width="33%" align="center">' + order.qty + '</td><td width="33%" align="center">' + (parseFloat(order.standard_rate)).toFixed(2) + '</td><td width="33%" align="right">' + (parseFloat(order.price)).toFixed(2) + '</td></tr>';
      });
      viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
      viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Net Total</b></td><td width="50%" align="right" colspan=3><b>' + parseFloat(this.netTotalAmount).toFixed(2) + '</b></td></tr>';
      viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>VAT</b></td><td width="50%" align="right" colspan=3><b>' + parseFloat(this.vatAmount).toFixed(2) + '</b></td></tr>';
      //console.log(parseFloat(this.discountAmount).toFixed(2))

      //if(parseFloat(this.discountAmount).toFixed(2) !== 0){
      if (Math.round(parseFloat(this.discountAmount) * 100) / 100 > 0) {

        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Discount</b></td><td width="50%" align="right" colspan=3><b>' + parseFloat(this.discountAmount).toFixed(2) + '</b></td></tr>';
      }
      //console.log(parseFloat(this.diffAmount).toFixed(2))
      //if(parseFloat(this.diffAmount).toFixed(2) !== 0.00){
      if (Math.round(parseFloat(this.discountAmount) * 100) / 100 > 0) {
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left" colspan=3><b>Diff</b></td><td width="50%" align="right" colspan=3><b>' + parseFloat(this.diffAmount).toFixed(2) + '</b></td></tr>';
      }

      viaInvStr = viaInvStr + '<tr style="font-size: 24px;"><td width="50%" align="left"colspan=3><b>Grand Total</b></td><td width="50%" align="right" colspan=3><b>' + this.grandTotalAmount.toFixed(2) + '</b></td></tr>';

      if (this.cashAmount > 0) {
        viaInvStr = viaInvStr + '<tr><td width="33%" align="left">Paid Amount</td><td width="33%" align="right" >Cash</td><td width="33%" align="right" >' + (parseFloat(this.cashAmount)).toFixed(2) + '</td></tr>';
      }
      if (this.creditAmount > 0) {
        viaInvStr = viaInvStr + '<tr><td width="33%" align="left"></td><td width="33%" align="right" >Credit : Visa</td><td width="33%" align="right" >' + (parseFloat(this.creditAmount)).toFixed(2) + '</td></tr>';
      }
      if (this.accountAmount > 0) {
        viaInvStr = viaInvStr + '<tr><td width="33%"> </td><td width="33%" align="right" >Account :</td><td width="33%" align="right" >' + (parseFloat(this.accountAmount)).toFixed(2) + '</td></tr>';
      }
      if (this.balance > 0) {
        viaInvStr = viaInvStr + '<tr><td width="33%" align="left"></td><td width="33%" align="right" >Gift :</td><td width="33%" align="right" >' + (parseFloat(this.balance)).toFixed(2) + '</td></tr>';
      }
      if (this.loyality !== null) {
        viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Customer name : </td><td align="left" width="33%" align="right" ><b>' + this.name + '</b></td><td width="33%" align="right" ></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Phone : </td><td align="left" width="33%" align="right" ><b>' + this.phone + '</b></td><td width="33%" align="right" ></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Address line 1 : </td><td align="left" width="33%" align="right" ><b>' + this.line1 + '</b></td><td width="33%" align="right" ></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Address line 2 </td><td align="left" width="33%" align="right" >:<b>' + this.line2 + '</b></td><td width="33%" align="right" ></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> Area : </td><td align="left" width="33%" align="right" ><b>' + this.area + '</b></td><td width="33%" align="right" ></td></tr>';
        viaInvStr = viaInvStr + '<tr><td width="33%" align="left"> City : </td><td align="left" width="33%" align="right" ><b>' + this.city + '</b></td><td width="33%" align="right" ></td></tr>';
      }
      /*
      if(this.notPaidAmount!==0){
        viaInvStr = viaInvStr + '<tr><td width="50%" align="left">Change</td><td width="50%" align="right" colspan=2>'+(-1*parseFloat(this.notPaidAmount)).toFixed(2)+'</td></tr>';
      }
      */
      viaInvStr = viaInvStr + '</table>';
      viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">' + this.invoiceFooter + '</td></tr></table>';
      viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">.</td></tr></table>';
      viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">.</td></tr></table>';
      viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">.</td></tr></table>';
      viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center">.</td></tr></table>';
      this.printElemm(viaInvStr);
      this.clearOrderState();

    },
    closeUserCash: async function (cashDetail) {

      try {
        let dateTimeStr = '';
        const nowDate = new Date();
        let year = nowDate.getFullYear();
        let month = nowDate.getMonth() + 1;
        let day = nowDate.getDate();
        let nowDateParam = year + '-' + month + '-' + day;
        console.log("nowDateParam", nowDateParam);
        let dataURL = this.apiURL + 'GiftCard/closeDailyShift';
        let closePosJson = { "appId": "7", "userId": localStorage.userId, "orderDate": nowDateParam };
        let response = await axios.post(dataURL, closePosJson);
        if (response.data.status === 'success') {

          this.printCashDetail(cashDetail);

        } else {
          this.showError = true;
        }
      }
      catch (error) {
        console.log(error);
      }

    },
    printCashDetail(cashDetail) {
      let cashDetailVal = [];
      cashDetailVal = cashDetail;
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      var today = new Date();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var cashier = localStorage.username;
      let viaInvStr = '';
      let totalCash = 0;

      viaInvStr = viaInvStr + '<p>VIAMENU Restaurant<br/>Cashier Closing</p>';
      viaInvStr = viaInvStr + '<tr><td> Date : ' + day + "/" + month + "/" + year + ' ' + time + '<br></td></tr>';
      viaInvStr = viaInvStr + '<tr><td> Cashier : ' + cashier + '<br></td></tr>';

      viaInvStr = viaInvStr + '<table align="center" width="100%"><tr bgcolor="#EEE">';
      viaInvStr = viaInvStr + '<td colspan=3 align="center"><b>CURRENCY TYPES</b></td>';
      viaInvStr = viaInvStr + '<td width="33%" align="center"><b>COUNT</b></td>';
      viaInvStr = viaInvStr + '<td width="33%" align="center"><b>VALUE</b></td>';
      viaInvStr = viaInvStr + '</tr>';
      cashDetailVal.forEach(function (cashDetailItem) {
        viaInvStr = viaInvStr + '<tr><td colspan=3 align="left">' + cashDetailItem.value + '</td><td width="33%" align="center">' + cashDetailItem.count + '</td><td width="33%" align="center">' + cashDetailItem.value + '</td></tr>';
        totalCash = totalCash + (cashDetailItem.value * cashDetailItem.count);
      });
      viaInvStr = viaInvStr + '<tr bgcolor="#EEE"><td width="50%" align="left" colspan=2><b>TOTAL:</b></td><td width="50%" align="right" colspan=3><b>' + totalCash + '</b></td></tr>';
      this.printElemm(viaInvStr);
      this.$router.push({ name: 'login' });
    },

    setAccountAmount(accountAmount1) {
      this.accountAmount = accountAmount1;
      if (Math.round(this.accountAmount * 100) / 100 >= Math.round(this.notPaidAmount * 100) / 100) {
        this.calcPaid();
        if (this.orderItems.length > 0 || this.currentItem.length > 0) {
          if (this.notPaidAmount > 0 || Math.round(parseFloat(this.notPaidAmount).toFixed(2) * 100) / 100 === 0) {
            this.startOrderProcessing();
          }
        } else {

          this.processPayment("-1");
        }
      } else {
        this.showAlert("You can not pay more than the remaining");
        this.isPayAccountOpen = true;
      }
      this.authorizedToPayReturn = "N";

    },

    setCustomerName(customername) {
      this.customername = customername;
    },
    setCustomer(customer) {
      this.customer = parseInt(customer);
    },

    setCustomernumber(customernumber) {
    },
    setCreditAmount(creditAmount) {
      let amount = parseFloat(creditAmount);
      if (isNaN(amount)) {
        return;
      }
      const remaining = Math.abs(parseFloat(this.notPaidAmount) || 0);
      if (Math.round(Math.abs(amount) * 100) / 100 <= Math.round(remaining * 100) / 100) {
        this.creditAmount = (-Math.abs(amount)).toFixed(2);
        this.calcPaid();
        if (this.orderItems.length > 0 || this.currentItem.length > 0) {
          if (
            this.notPaidAmount > 0 ||
            Math.round(parseFloat(this.notPaidAmount).toFixed(2) * 100) / 100 === 0
          ) {
            this.startOrderProcessing();
          }
        } else {
          this.processPayment("-1");
        }
      } else {
        this.showAlert("You can not pay more than the remaining");
        this.isPayCreditOpen = true;
      }
      this.authorizedToPayReturn = "N";
    },
    setMobileAmount(mobileAmountObj) {
      let mobileAmount = mobileAmountObj.amount;
      this.paymentProvider = mobileAmountObj.provider;
      let amountNum = parseFloat(mobileAmount);
      if (isNaN(amountNum)) {
        return;
      }
      const remaining = Math.abs(parseFloat(this.notPaidAmount) || 0);
      if (Math.round(Math.abs(amountNum) * 100) / 100 <= Math.round(remaining * 100) / 100) {
        this.mobileAmount = (-Math.abs(amountNum)).toFixed(2);
        this.calcPaid();
        if (this.orderItems.length > 0 || this.currentItem.length > 0) {
          if (
            this.notPaidAmount > 0 ||
            Math.round(parseFloat(this.notPaidAmount).toFixed(2) * 100) / 100 === 0
          ) {
            this.startOrderProcessing();
          }
        } else {
          this.processPayment("-1");
        }
      } else {
        this.showAlert("You can not pay more than the remaining");
        this.isPayMobileOpen = true;
      }
    },
    setCashAmount(cashAmount) {
      let amount = parseFloat(cashAmount);
      if (isNaN(amount)) {
        return;
      }
      amount = -Math.abs(amount);
      this.cashAmount = amount;
      this.calcPaid();
      if (this.orderItems.length > 0 || this.currentItem.length > 0) {
        if (this.notPaidAmount > 0 || Math.round(parseFloat(this.notPaidAmount).toFixed(2) * 100) / 100 === 0) {
          this.startOrderProcessing();
        }
      } else {
        this.processPayment("-1");
      }
      this.authorizedToPayReturn = "N";
    },

    setNewProductData(newProductData) {
      this.products.push({
        "item_name": newProductData.item_name,
        "arabic_item_name": newProductData.item_name,
        "item_group": newProductData.item_name,
        "barcode": newProductData.newproductbarcode,
        "standard_rate": newProductData.newproductprice,
        "item_code": newProductData.newproductbarcode,
        "item_discount": newProductData.item_discount
      })
      let newProduct = {};
      newProduct.item_name = newProductData.item_name;
      newProduct.arabic_item_name = newProductData.item_name;
      newProduct.item_group = newProductData.item_name;
      newProduct.barcode = newProductData.newproductbarcode;
      newProduct.standard_rate = newProductData.newproductprice;
      newProduct.item_code = newProductData.newproductbarcode;
      newProduct.price = newProductData.price;
      newProduct.item_discount = newProductData.item_discount;
      //newProduct.standard_rate_vat = parseFloat(newProductData.newproductprice*1.05).toFixed(2);
      //newProduct.price_vat = parseFloat(newProductData.newproductprice*1.05).toFixed(2);
      if (this.products.length === 1) {
        this.addProductToOrder(newProduct);
        this.products = [];
        this.barcode = '';
      }
    },


    setGiftCardInfos(giftCardInfos) {
      this.loyality = null;
      this.giftCardInfos = giftCardInfos;
      if (this.giftCardInfos.status === 'success') {
        this.customerId = this.giftCardInfos.results[0].customernumber;
      } else {
      }
      this.giftcardnumber = this.giftCardInfos.results[0].giftcardnumber;
      this.giftcardname = this.giftCardInfos.results[0].giftcardname;
      this.balance = this.giftCardInfos.results[0].balance;
      if (this.balance <= this.notPaidAmount) {
        this.calcPaid();
        if (this.orderItems.length > 0 || this.currentItem.length > 0) {
          if (this.notPaidAmount > 0 || Math.round(parseFloat(this.notPaidAmount).toFixed(2) * 100) / 100 === 0) {
            this.startOrderProcessing();
          }
        } else {

          this.processPayment("-1");
        }
      } else {
        this.showAlert("You can not pay more than the remaining");
      }
    },
    clearLoialityData() {
      this.loyality = null;
      this.showloyality = false;
      this.giftCardInfos = null;
      this.loyality = null;
      this.dis_percentage = 0;
      this.customernumber = "";
      this.name = "";
      this.gender = "";
      this.email = "";
      this.phone = "";
      this.customerId = 0;
      this.customer = 0;

      this.line1 = "";
      this.line2 = "";
      this.city = "";
      this.area = "";
      this.totalpoints = "";
      this.customerBalance = "";
      this.earnedpoints = 0;
      this.customersince = "";

    },

    setLoialityPoints(loyality) {
      this.giftCardInfos = null;
      this.loyality = loyality;
      this.showloyality = true;
      this.dis_percentage = parseFloat(this.loyality.results[0].dis_percentage).toFixed(2);
      this.customernumber = this.loyality.results[0].customernumber;
      this.name = this.loyality.results[0].name;
      this.gender = this.loyality.results[0].gender;
      this.email = this.loyality.results[0].email;
      this.phone = this.loyality.results[0].phone;
      this.customerId = this.loyality.results[0].id;
      //this.customer = this.loyality.results[0].id;
      //console.log("this.loyality.results[0]", this.loyality.results[0]);
      this.line1 = this.loyality.results[0].line1;
      this.line2 = this.loyality.results[0].line2;
      this.city = this.loyality.results[0].city;
      this.area = this.loyality.results[0].area;

      this.totalpoints = this.loyality.results[0].totalpoints;
      this.customerBalance = this.loyality.results[0].balance;
      
      this.customersince = this.loyality.results[0].customersince;

    },

    updateCustomerBalance: async function (account, amount) {
      try {
        let dataURL = this.apiURL + 'Orders/updateCustomerBalance';
        let customerBalanceJson = { "appId": "7", "customerId": account, "balance": amount };
        let response = await axios.post(dataURL, customerBalanceJson);
        if (response.data.status === 'success') {

        }
      }
      catch (error) {
        console.log(error);
      }
    },

    processPayment: async function (orderId) {
      try {
        this.isPaid = false;
        let cash = this.cashAmount;
        cash = (parseFloat(this.grandTotalAmount).toFixed(2) - (Math.round(parseFloat(this.creditAmount).toFixed(2) * 100) / 100 + Math.round(parseFloat(this.accountAmount).toFixed(2) * 100) / 100 + Math.round(parseFloat(this.balance).toFixed(2) * 100) / 100));
        let accountid = 0;
        if (this.customer !== 0) {
          accountid = this.customer;
        }
        let tempAcc = 0;
        if (this.grandTotalAmount === 0) {
          tempAcc = this.customerId;
        }
        const paymentDetails = [
          { "paymenttype": "cash", "amount": parseFloat(cash).toFixed(2), "accountid": tempAcc },
          { "paymenttype": "credit", "amount": parseFloat(this.creditAmount).toFixed(2), "accountid": tempAcc },
          { "paymenttype": "mobile", "amount": parseFloat(this.mobileAmount).toFixed(2), "accountid": tempAcc, "provider": this.paymentProvider },
          { "paymenttype": "account", "amount": parseFloat(this.accountAmount).toFixed(2), "accountid": accountid },
          { "paymenttype": "giftcard", "cardnumber": this.giftcardnumber, "amount": parseFloat(this.balance).toFixed(2), "accountid": tempAcc }];
        let dataURL = this.apiURL + 'Orders/payOrder';
        let paymentsJson = { "customerId":this.customerId,"appId": localStorage.appId, 'orderId': orderId, "added_by": localStorage.userId, "paymentDetails": paymentDetails };
        let response = await axios.post(dataURL, paymentsJson);
        let totalAmount = 0;
        if (response.data.status === 'success') {
          this.earnedpoints = response.data.earnedpoints;
        
          if (tempAcc !== 0) {
            let amount = -1 * parseFloat(this.cashAmount + this.creditAmount + this.balance).toFixed(2)
            this.updateCustomerBalance(tempAcc, amount);
          }
          if (accountid !== 0) {
            this.updateCustomerBalance(accountid, parseFloat(this.accountAmount).toFixed(2));

          }
          if (this.posData.efris_on) {
          const qr = await this.handleURA();
          if (qr) {
            this.printUgandaOrder();
          }
        } else {
          this.printUgandaOrder();
        }
          if (this.isPrinted) {
            this.customer = 0;
            this.clearPayments();
            this.isPaid = true;
            this.currentOrderDirty = false;
            this.showChange = true;
            this.clearOrderState();
          }
        }
      }
      catch (error) {
        console.log(error);
      }
    },
    async handleURA() {
      this.showInfo("Processing Invoice With URA")
      let uraJson = {
        username: localStorage.username,
        invoiceId: this.currentOrderId
      };
      // let items = [];
      // let taxItems = [];
      // let qty = 0;
      // this.currentItem.forEach(function (order) {
      //   qty += order.qty;
      //   items.push({
      //     item: order.item_name,
      //     itemCode: order.item_code,
      //     qty: order.qty,
      //     unitOfMeasure: "101",
      //     unitPrice: order.standard_rate,
      //     total: order.total,
      //     taxRate: 1 - parseFloat(order.tax),
      //     tax: Math.ceil(order.total / order.tax),
      //     discountTotal: "",
      //     discountTaxRate: "",
      //     orderNumber: this.currentOrderId,
      //     discountFlag: "2",
      //     deemedFlag: "2",
      //     exciseFlag: "2",
      //     categoryId: "",
      //     categoryName: "",
      //     goodsCategoryId: "",
      //     goodsCategoryName: "",
      //     exciseRate: "",
      //     exciseRule: "",
      //     exciseTax: "",
      //     pack: "1",
      //     stick: "1",
      //     exciseUnit: "",
      //     exciseCurrency: "",
      //     exciseRateName: "",
      //     vatApplicableFlag: "1"
      //   })
      //   taxItems.push({
      //     "taxCategoryCode": order.taxRateName == "Standard" ? "01" : order.taxRateName == "Exempted" ? "03" : "02",
      //     "netAmount": Math.ceirl(order.total / order.tax),
      //     "taxRate": 1 - parseFloat(order.tax),
      //     "taxAmount": Math.ceil(order.total - (order.total / order.tax)),
      //     "grossAmount": order.total,
      //     "exciseUnit": "",
      //     "exciseCurrency": "",
      //     "taxRateName": order.taxRateName
      //   })
      // });
      // this.orderItems.forEach(function (order) {
      //   qty += order.qty;
      //   items.push({
      //     item: order.item_name,
      //     itemCode: order.item_code,
      //     qty: order.qty,
      //     unitOfMeasure: "101",
      //     unitPrice: order.standard_rate,
      //     total: order.total,
      //     taxRate: 1 - parseFloat(order.tax),
      //     tax: Math.ceil(order.total / order.tax),
      //     discountTotal: "",
      //     discountTaxRate: "",
      //     orderNumber: this.currentOrderId,
      //     discountFlag: "2",
      //     deemedFlag: "2",
      //     exciseFlag: "2",
      //     categoryId: "",
      //     categoryName: "",
      //     goodsCategoryId: "",
      //     goodsCategoryName: "",
      //     exciseRate: "",
      //     exciseRule: "",
      //     exciseTax: "",
      //     pack: "1",
      //     stick: "1",
      //     exciseUnit: "",
      //     exciseCurrency: "",
      //     exciseRateName: "",
      //     vatApplicableFlag: "1"
      //   })
      //   taxItems.push({
      //     "taxCategoryCode": order.taxRateName == "Standard" ? "01" : order.taxRateName == "Exempted" ? "03" : "02",
      //     "netAmount": Math.ceirl(order.total / order.tax),
      //     "taxRate": 1 - parseFloat(order.tax),
      //     "taxAmount": Math.ceil(order.total - (order.total / order.tax)),
      //     "grossAmount": order.total,
      //     "exciseUnit": "",
      //     "exciseCurrency": "",
      //     "taxRateName": order.taxRateName
      //   })
      // });
      // let pays = [];
      // let payTotal = 0;

      // if (Math.round(parseFloat(this.cashAmount) * 100) / 100 > 0) {
      //   payTotal += this.cashAmount;
      //   pays.push({
      //     "paymentMode": "102",
      //     "paymentAmount": this.cashAmount,
      //     "orderNumber": "a"
      //   })
      // }

      // if (Math.round(parseFloat(this.creditAmount) * 100) / 100 > 0) {
      //   payTotal += this.creditAmount;
      //   pays.push({
      //     "paymentMode": "106",
      //     "paymentAmount": this.creditAmount,
      //     "orderNumber": "a"
      //   })
      // }

      // if (Math.round(parseFloat(this.mobileAmount) * 100) / 100 > 0) {
      //   payTotal += this.mobileAmount;
      //   pays.push({
      //     "paymentMode": "105",
      //     "paymentAmount": this.mobileAmount,
      //     "orderNumber": "a"
      //   })
      // }

      // if (Math.round(parseFloat(this.accountAmount) * 100) / 100 > 0) {
      //   payTotal += this.accountAmount;
      //   pays.push({
      //     "paymentMode": "101",
      //     "paymentAmount": this.accountAmount,
      //     "orderNumber": "a"
      //   })
      // }
      // uraJson.payments = pays;
      // uraJson.tax_details = taxItems;
      // uraJson.items = items;
      // uraJson.summary = {
      //   netAmount: this.netTotalAmount,
      //   taxAmount: this.taxAmount,
      //   grossAmount: this.grandTotalAmount,
      //   itemCount: qty,
      //   modeCode: "0",
      //   remarks: "Remark",
      //   qrCode: "testqr"
      // }
      let dataURL = this.apiURL + 'SyncEfris/generateSyncReturnsInvoice';
      let response = await axios.post(dataURL, uraJson);
      if (response.data.status === 'success') {
        let req = {
          data: {
            content: response.data.req_obj,
            signature: "",
            dataDescription: {
              codeType: "0",
              encryptCode: "0",
              zipCode: "0",
            },
          },
          globalInfo: {
            appId: "AP04",
            version: "1.1.20191201",
            dataExchangeId: "923048922301214123",
            interfaceCode: "T109",
            requestCode: "TP",
            requestTime: this.getCurrentDateTime(),
            responseCode: "TA",
            userName: localStorage.getItem("username"),
            deviceMAC: "FFFFFFFFFFFF",
            deviceNo: "TCS7fbfeb469484346",
            tin: "1010950825",
            brn: "",
            taxpayerID: "ETX999000001356715",
            longitude: "116.397128",
            latitude: "39.916527",
            extendField: {
              responseDateFormat: "dd/MM/yyyy",
              responseTimeFormat: "dd/MM/yyyy HH:mm:ss",
              referenceNo: "21PL010020807",
            },
          },
          returnStateInfo: {
            returnCode: "",
            returnMessage: "",
          },
        };
        let resp = await axios.post(this.posData.efris_link, req);
        if (resp.data.returnStateInfo.returnMessage == 'SUCCESS') {
          let info = JSON.parse(atob(resp.data.data.content)).basicInformation;
          let uraToPosJson = {
            invoiceId: this.currentOrderId,
            ura_invoice_id: info.invoiceId,
            ura_invoice_no: info.invoiceNo,
          };
          dataURL = this.apiURL + 'SyncEfris/setSyncedReturnsInvoice';
          response = await axios.post(dataURL, uraToPosJson);
          if (response.data.status === 'success') {
            this.showSuccess("Synced To URA");
            return info.invoiceId;
          } else {
            this.showAlert("Error Syncing With URA")
          }
        } else {
          this.showAlert("Error Syncing With URA")
        }
      }

    },
    processOrder: async function (status) {
      this.totalPaymentAmount = this.grandTotalAmount;
      const nowDate = new Date();
      let orderDetailItems = [];
      let newOrderId = '';
      if (this.currentOrderId === '') {
        newOrderId = -1;
      } else {
        newOrderId = this.currentOrderId;
      }
      try {
        if (this.orderItems.length > 0) {
          this.orderItems.forEach(function (order) {
            orderDetailItems.push({ "barcode": order.barcode, "item_group": order.item_group, "item_code": order.item_code, "item_name": order.item_name, "qty": order.qty, "standard_rate": parseFloat(order.standard_rate).toFixed(2), "price": parseFloat(order.price).toFixed(2), "item_discount": parseFloat(order.item_discount).toFixed(2) });
          });
        }
        if (this.currentItem.length > 0) {
          this.currentItem.forEach(function (order) {
            orderDetailItems.push({ "barcode": order.barcode, "item_group": order.item_group, "item_code": order.item_code, "item_name": order.item_name, "qty": order.qty, "standard_rate": parseFloat(order.standard_rate).toFixed(2), "price": parseFloat(order.price).toFixed(2), "item_discount": parseFloat(order.item_discount).toFixed(2) });
          });
        }

        let orderDateTime = '2022-04-23 15:59:22';
        orderDateTime = this.getCurrentDateTime();
        this.orderHeader.appId = localStorage.appId;
        this.orderHeader.userId = localStorage.userId;
        this.orderHeader.username = localStorage.username;
        this.orderHeader.orderId = newOrderId;
        this.orderHeader.orderDate = orderDateTime;
        this.orderHeader.discount = this.discountAmount;
        this.orderHeader.totalamount = parseFloat(this.grandTotalAmount).toFixed(2);
        this.orderHeader.customerId = this.customerId;
        this.orderHeader.status = status;
        this.orderHeader.customer_name = this.name;
        this.orderHeader.orderDetail = orderDetailItems;
        let orderJason = JSON.stringify(this.orderHeader);
        let itIsOk = true;
        if (status === "3" && this.name === "") {
          itIsOk = false;
          this.showAlert("Please select a customer");
        }
        if (status === "2" && this.discountAmount !== 0) {
          itIsOk = false;
          this.showError = true;
          this.mainErrorMsg = "This invoice alredy has a discount";
        }
        if (itIsOk) {
          let dataURL = this.apiURL + 'Orders/createOrder';
          let response = await axios.post(dataURL, orderJason);
          if (response.data.status === 'success') {
            if (this.customerId != 0) {
              //this.getCustomerById(this.customerId);
            }
            this.currentOrderId = response.data.invoice;
            if (status === "3") {
              this.startDeliveryOrderProcessing();
            } else {
              if (status === "2") {
                this.discountRequestedSize = this.discountRequestedSize + 1;
                this.clearOrderState();
              } else {
                if (status === "1") {
                  this.parkedSize = this.parkedSize + 1;
                  this.clearOrderState();
                } else {
                  this.processPayment(this.currentOrderId);
                }
              }
            }
          } else {
            if (response.data.status === "errorDelivery") {
              if (status === "0") {
                this.processPayment(this.currentOrderId);
              } else {
                this.showAlert("Delivery Order Cannot Be Amended");
              }
            }
          }
        }
      }
      catch (error) {
        console.log(error);
      }
    },

    clearOrderState() {
      this.orderItems = [];
      this.currentItem = [];
      this.clearPayments();
      this.notPaidAmount = 0;
      this.discountAmount = 0;
      this.vatAmount = 0;
      this.netTotalAmount = 0;
      this.grandTotalAmount = 0;
      this.diffAmount = 0;
      this.outstandingAmount = this.notPaidAmount.toString();
      this.dis_percentage = 0;
      this.prompMinimum_total = 0;
      this.promoDiscount = 0;
      //this.totalOrderAmount = 0;
      this.currentOrderId = '';
      // this.customer = "";
      this.currentOrderDirty = false;
      //this.orderParkStatus = "";
      this.clearLoialityData();
    },

    clearOrder: function () {
      this.orderItems = [];
      this.isPaymentOpen = !this.isPaymentOpen
    },
    greet: function (event) {
      if (event) {
        alert(event.target.tagName)
      }
    },
    saveNewPrice: function (barcode) {
      let tempOrderItems = [];
      tempOrderItems = this.orderItems.filter(function (a) {
        if (a.barcode != null) {
          if (a.barcode.toLowerCase() === barcode) {
            return true;
          }
        }
        return false;
      }
      );
      if (tempOrderItems.length > 0) {
        tempOrderItems[0].price = this.editedPrice;
        this.toggle = true;
        localStorage.removeItem('authorizedToChangePrice');
        this.calcOrderTotalAmount();
      }
    },

    hideBtnShowText: function (barcode) {
      this.authorizedToChangePrice = localStorage.authorizedToChangePrice;
      if (this.authorizedToChangePrice === 'Y') {
        this.$el.querySelector('#Barcode').focus = false;
        this.$el.querySelector('#currentItemQty').focus = false;
        this.$el.querySelector('#currentItemPrice').focus = true;

        let tempOrderItems = [];
        tempOrderItems = this.orderItems.filter(function (a) {
          if (a.barcode != null) {
            if (a.barcode.toLowerCase() === barcode) {
              return true;
            }
          }
          return false;
        }
        );
        if (tempOrderItems.length === 1) {
          this.editedRoderItem = tempOrderItems;
          this.toggle = false;
          this.editedPrice = tempOrderItems[0].price;
        }
      } else {
        this.isVoidOpen = true;
      }
    },
    getPromotion: async function (product) {
      let promo_data = {};
      let currentPromotion = [];
      let order_item = {};
      promo_data.minimum_total = 0;
      promo_data.discount = 0;
      order_item.item_name = product.item_name;
      order_item.arabic_item_name = product.arabic_item_name;
      order_item.item_group = product.item_group;
      order_item.barcode = product.barcode;
      order_item.standard_rate = product.standard_rate;
      order_item.item_code = product.item_code;
      order_item.price = product.price;
      order_item.item_discount = product.item_discount;
      currentPromotion = this.promotions.filter(function (a) {
        if (product.item_group !== null) {
          if (a.item_group.toLowerCase() === product.item_group.toLowerCase()) {
            return true;
          }
        }
        return false;
      });

      if (currentPromotion.length > 0) {
        if (currentPromotion[0].minimum_total > 0 && currentPromotion[0].discount > 0) {

          order_item.item_discount = parseFloat(currentPromotion[0].discount) * order_item.price / 100;
          this.prompMinimum_total = currentPromotion[0].minimum_total;
        }


      } else {

        try {
          let dataURL = this.apiURL + 'Products/getPromos';
          let response = await axios.post(dataURL, { "appId": localStorage.appId, "item_group": product.item_group });

          if (response.data.status === 'success') {
            if (response.data.results.promotions.length > 0) {
              promo_data.minimum_total = response.data.results.promotions[0].minimum_total;
              promo_data.discount = response.data.results.promotions[0].discount;
              this.promotions.push({
                "item_group": product.item_group,
                "minimum_total": promo_data.minimum_total,
                "discount": promo_data.discount,
              });
              if (promo_data.minimum_total > 0 && promo_data.discount > 0) {
                order_item.item_discount = parseFloat(promo_data.discount) * order_item.price / 100;
                this.prompMinimum_total = promo_data.minimum_total;
              } else {
                order_item.item_discount = 0;
              }
            }
          } else {
            order_item.item_discount = 0;
          }
        }
        catch (error) {
          console.log(error);
        }
      }

      this.addProductToOrder(order_item);
      this.products = [];
      this.barcode = '';
    },

    getProduct: async function (barcodeVar) {
      if (barcodeVar !== '') {
        try {
          let dataURL = this.apiURL + 'Products/findProductLocal?appId=7&barcode=' + barcodeVar;
          let response = await axios.post(dataURL, { "appId": localStorage.appId, "barcode": barcodeVar });
          if (response.data.status === 'success') {
            this.products = response.data.results.products;
            if (this.products.length === 1) {
              let addedProduct = {};
              addedProduct.item_name = this.products[0].item_name;
              addedProduct.arabic_item_name = this.products[0].arabic_item_name;
              addedProduct.item_group = this.products[0].item_group;
              addedProduct.barcode = this.products[0].barcode;
              addedProduct.standard_rate = this.products[0].standard_rate;
              addedProduct.item_code = this.products[0].item_code;
              addedProduct.price = this.products[0].price;
              addedProduct.item_discount = 0;
              addedProduct.tax = this.products[0].tax;
              addedProduct.uom = this.products[0].uom;
              this.addProductToOrder(addedProduct);
              this.calcOrderTotalAmount();

              this.products = [];
              this.barcode = '';
            }
            else {
              let suffixL = this.posData.suffix_length;
              barcodeVar = barcodeVar.substring(0, barcodeVar.length - suffixL)
              let newBacode = '';
              let item_price = '';
              let item_qty = '';
              let newBacodeType = '';
              let barcodeDefLength = parseInt(this.posData.scale_barcode_length);
              let prefixQ = this.posData.prefix_barcode_qty.length;

              if (prefixQ > 0) {
                newBacodeType = barcodeVar.substring(0, prefixQ);
                newBacode = barcodeVar.substring(prefixQ, barcodeDefLength + prefixQ);
                if (newBacodeType === this.posData.prefix_barcode_qty) {
                  item_qty = barcodeVar.substring(barcodeDefLength + prefixQ, barcodeVar.length - 1) + "0";
                  this.getNewProduct(newBacode, item_qty, item_price, newBacodeType);
                  return;
                }
              }
              let prefixP = this.posData.prefix_barcode_prc.length;
              newBacodeType = barcodeVar.substring(0, prefixP);
              newBacode = barcodeVar.substring(prefixP, barcodeDefLength + prefixP);
              if (newBacodeType === this.posData.prefix_barcode_prc) {
                item_price = barcodeVar.substring(barcodeDefLength + prefixP, barcodeVar.length);
                this.getNewProduct(newBacode, item_qty, item_price, newBacodeType);
              } else if (barcodeVar === "7777777") {
                this.isNewProductOpen = true;
              } else {
                // saveBarcode
                this.showAlert("Item not found please try again");
                this.saveBarcode(barcodeVar);

              }
            }
            // else
            // {

            //   let newBacode = '';
            //   let item_price = '';
            //   let item_qty = '';
            //   let newBacodeType = '';    

            //   newBacodeType = barcodeVar.substring(0,2);
            //   newBacode = barcodeVar.substring(2,7);
            //   if(newBacodeType === '99'){
            //     item_price = barcodeVar.substring(7,barcodeVar.length);
            //     this.getNewProduct(newBacode, item_qty, item_price);
            //   }else if(newBacodeType === '97'){
            //     item_qty = barcodeVar.substring(7,barcodeVar.length-1)+"0";
            //     this.getNewProduct(newBacode, item_qty, item_price);

            //   }else if(barcodeVar === "7777777"){
            //       this.isNewProductOpen = true;
            //   }else{
            //     // saveBarcode
            //     this.showAlert("Item not found please try again");
            //     this.saveBarcode(barcodeVar);

            //   }
            // }

          }
        }
        catch (error) {
          console.log(error);
        }


      }
    },
    getNewProduct: async function (newBarcode, item_qty, item_price) {
      try {
        let dataURL = this.apiURL + 'Products/findProductLocal?appId=7&barcode=' + newBarcode;
        let response = await axios.post(dataURL, { "appId": localStorage.appId, "barcode": newBarcode });
        this.products = response.data.results.products;

        if (this.products.length === 1) {
          let taxBase = 1;
          let price = 0;
          if (this.products[0].tax == 'Standard') {
            taxBase = this.taxBaseAmount;
          }
          let standard_rate = parseFloat(Math.ceil(this.products[0].standard_rate / 100) * 100).toFixed(2);
          let qty = 0;
          if (item_price !== '') {
            price = parseFloat(Math.ceil(item_price / 100) * 100).toFixed(2);
            if (standard_rate > 0) {
              qty = (item_price*1000)/(standard_rate*1000)
              // qty = parseFloat(price / standard_rate).toFixed(2);
            }
          } else if (item_qty !== '') {

            qty = parseFloat((item_qty / 10000)).toFixed(3);
            price = parseFloat(qty * standard_rate).toFixed(2);
          }
          this.seqId = this.seqId + 1;
          if (this.currentItem.length !== 0) {
            this.orderItems.push(this.currentItem[0]);
            this.currentItem = [];
          }
          this.orderItems.push({ "seqId": this.seqId, "item_discount": 0, tax: taxBase, "uom": this.products[0].uom, "item_code": this.products[0].item_code, "item_name": this.products[0].item_name, "item_group": this.products[0].item_group, "barcode": newBarcode, "price": -1 * parseFloat(price).toFixed(2), "standard_rate": parseFloat(standard_rate).toFixed(2), "qty": -1 * parseFloat(qty).toFixed(3) });
          this.calcOrderTotalAmount();
          this.products = [];
          this.barcode = '';
        } else {
          this.showAlert("Item not found please try again");
          this.saveBarcode(newBarcode);
        }
      }
      catch (error) {
        console.log(error);
      }
    },
    calcOrderTotalAmount: function () {
      // if (this.invoiceDiscount > 0) {
      // } else {
      //   this.discountAmount = this.calcPromoDiscount(this.calcOrderNetTotal());
      // }
      this.vatAmount = parseInt(this.calcOrderVatTotal());
      this.netTotalAmount = parseInt(this.calcOrderNetTotal());
        
      this.grandTotalAmount = this.netTotalAmount + this.vatAmount- parseInt(this.calcOrderDiscount());
      this.calcPaid();
      // this.netTotalAmount = this.calcOrderNetTotal();
      // this.grandTotalAmount = this.calcOrderNetTotal() - this.discountAmount;
      // this.vatAmount = this.grandTotalAmount - (this.grandTotalAmount) / 1.05;
      // this.netTotalAmount = this.grandTotalAmount - this.vatAmount;
      // this.diffAmount = this.calcAmountPrecision(this.grandTotalAmount) - this.grandTotalAmount;
      // this.grandTotalAmount = this.grandTotalAmount + this.diffAmount;
      // this.calcPaid();
    },

    calcOrderNetTotal: function () {
      let orderAmount = 0;
      if (this.orderItems.length > 0) {
        let tax = this.taxBaseAmount;
        this.orderItems.forEach(function (order) {
          let price = order.standard_rate;
          if(order.tax == 'Standard' || order.tax != 1){
            price = order.standard_rate / tax;
          }
          
          orderAmount = orderAmount + Math.round(price * order.qty);
        });
      }
      if (this.currentItem.length > 0) {
        let tax = this.taxBaseAmount;
        this.currentItem.forEach(function (order) {
          let price = order.standard_rate;
          if(order.tax == 'Standard'|| order.tax != 1){
            price = order.standard_rate / tax
          }
          
          orderAmount = orderAmount + Math.round(price * order.qty);
        });
      }
      return orderAmount;
    },
    getTaxAmount: async function () {
      try {

        let dataURL = this.apiURL + 'Products/getTaxAmount';
        let response = await axios.post(dataURL, {});
        if (response.data.status === 'success') {
          this.taxBaseAmount = response.data.tax;
        }
      }
      catch (error) {
        console.log(error);
      }
    },
    calcOrderDiscount: function () {
      let dis = 0;
      if (this.discountAmount !== 0) {
        dis = this.discountAmount;
      } else {
        let promoDis = 0;
        if (this.prompMinimum_total <= this.netTotalAmount) {
          if (this.orderItems.length > 0) {
            this.orderItems.forEach(function (order) {
              if (order.item_discount != null && order.item_discount !== undefined) {
                promoDis = promoDis + parseFloat(order.item_discount) * order.price / 100;
              }
            });
          }

          if (this.currentItem.length > 0) {
            this.currentItem.forEach(function (order) {
              if (order.item_discount != null && order.item_discount !== undefined) {
                promoDis = promoDis + parseFloat(order.item_discount) * order.price / 100;
              }
            });
          }
        }
        dis = promoDis;
        let persDis = 0;
        if (this.dis_percentage > 0) {
          persDis = this.netTotalAmount * (this.dis_percentage / 100);
        }

        if (persDis > promoDis) {
          dis = persDis;
        }

      }
      return dis;
    },

    calcPrecision: function (amount) {
      let prcision = 0;
      let amountDiff = 0;
      let diff = parseFloat(amount).toFixed(2) - Math.round((parseFloat(amount).toFixed(2)));
      diff = Math.round(diff * 100) / 100;
      if (diff < 0) {
        diff = 1 + diff;
      }
      if (diff > 0) {
        if (diff >= 0 && diff <= 0.12) {
          prcision = 0
          amountDiff = 0 - diff;
        }
        if (diff > 0.12 && diff <= 0.37) {
          prcision = 0.25
          amountDiff = 0.25 - diff;
        }
        if (diff > 0.37 && diff <= 0.62) {
          prcision = 0.50;
          amountDiff = 0.5 - diff;
        }

        if (diff > 0.62 && diff <= 0.87) {
          prcision = 0.75;
          amountDiff = 0.75 - diff;
        }
        if (diff > 0.87 && diff <= 1) {
          prcision = 1;
          amountDiff = 1 - diff;
        }
        amountDiff = Math.round(amountDiff * 1000) / 1000;
      }
      prcision = parseFloat(((Math.round(prcision * 1000)) / 1000)).toFixed(2);
      return amountDiff;
    },

    calcAmountPrecision: function (amount) {
      this.calcPrecision(amount)
      return amount + this.calcPrecision(amount);
    },


    addProductToOrder: function (product) {
      this.changeAmount = 0;
      this.showChange = false;
      let taxBase = 1;
      if (product.tax == 'Standard') {
          taxBase = this.taxBaseAmount;
        }
      if (this.currentItem.length === 0) {
        
        this.currentItem.push({
          "seqId": this.seqId,
          "barcode": product.barcode,
          "item_code": product.item_code,
          "item_name": product.item_name,
          "item_group": product.item_group,
          "standard_rate": parseFloat(product.standard_rate).toFixed(2),
          "price": parseFloat(-1 * product.standard_rate).toFixed(2),
          "qty": -1,
          "uom": product.uom,
          "tax": taxBase,
          "item_dis_price": product.item_dis_price,
          "item_discount": product.item_discount
        });
        this.calcOrderTotalAmount();
      } else {
        let tempOrderItems = [];
        tempOrderItems = this.orderItems.filter(function (a) {
          if (product.barcode !== null) {
            if (a.barcode.toLowerCase() === product.barcode) {
              return true;
            }
          }
          return false;
        });
        if (tempOrderItems.length > 0) {
          for (var i = 0; i < this.orderItems.length; i++) {
            if (this.orderItems[i].barcode === product.barcode) {
              let newItem = this.orderItems[i];
              newItem.qty = -1 * (this.orderItems[i].qty + 1);
              //newItem.price = newItem.qty * this.orderItems[i].standard_rate;
              newItem.price = newItem.qty * parseFloat(this.orderItems[i].standard_rate).toFixed(2);
              this.orderItems.splice(i, 1);
              this.orderItems.push(this.currentItem[0]);
              this.currentItem = [];
              this.currentItem.push(newItem);
            }
          }
          this.calcOrderTotalAmount();
        } else {
          if (product.barcode === this.currentItem[0].barcode) {
            this.currentItem[0].qty = (this.currentItem[0].qty - 1);
            this.currentItem[0].price = this.currentItem[0].standard_rate * this.currentItem[0].qty;
            this.calcOrderTotalAmount();

          } else {
            this.seqId = this.seqId + 1;
            this.orderItems.push(this.currentItem[0]);
            this.orderItems.reverse();
            this.orderItems.reverse();
            this.currentItem = [];

            this.currentItem.push({
              "seqId": this.seqId,
              "item_code": product.item_code,
              "item_name": product.item_name,
              "item_group": product.item_group,
              "barcode": product.barcode,
              "standard_rate": parseFloat(product.standard_rate).toFixed(2),
              "price": parseFloat(-1 * product.standard_rate).toFixed(2),
              "qty": -1,
              "uom": product.uom,
              "tax": taxBase,
              "item_discount": product.item_discount
            });
            this.calcOrderTotalAmount();
          }
        }
      }
      this.currentOrderDirty = true;
    },
  },


  created: async function (barcodeVar) {

  },
  setup() {
    const isOpen = ref(false);
    const isPaymentOpen = ref(false);
    const isLoyalityOpen = ref(false);
    const isGiftCardOpen = ref(false);
    const isVoidOpen = ref(false);
    const isCheckPriceOpen = ref(false);
    const isNewProductOpen = ref(false);
    //const isKeyboardOpen = ref(false);     

    const isKeypadOpen = ref(false);
    const isPayCashOpen = ref(false);
    const isPayCreditOpen = ref(false);
    const isPayAccountOpen = ref(false);
    const isPayMobileOpen = ref(false);

    const isCloseCashOpen = ref(false);
    const isShowInfosOpen = ref(false);

    const totalPaymentAmount = ref(Number);

    let orderItems = ref(Array);
    const orderId = ref(String);
    const customernumber = ref(String);

    return { isOpen, isPaymentOpen, totalPaymentAmount, isLoyalityOpen, isGiftCardOpen, isVoidOpen, isKeypadOpen, isCheckPriceOpen, isPayCashOpen, isPayCreditOpen, isPayAccountOpen, isPayMobileOpen, isCloseCashOpen, isShowInfosOpen, isNewProductOpen }
  }
}
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 20px;
}

.glyphicon.glyphicon-ok {
  font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #EEEEEE;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #CCCCCC;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #CCCCCC; */
}

.grid-container-element {
  display: grid;
  grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr;
  grid-gap: 10px;
  border: 1px solid whitesmoke;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  width: 100%;
}

.grid-child-element_ {
  margin: 10px;
  border: 1px solid red;
}

.grid-child-element {
  margin: 2px;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  padding: 0 px;

}

.swal2-title {
  font-family: monospace !important;
  color: red;
}

.numberCircleGreen {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  padding: 8px;

  background: green;
  border: 2px solid #666;
  color: #666;
  text-align: center;

  font: 32px Arial, sans-serif;
}

.numberCircleRed {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  padding: 8px;

  background: red;
  border: 2px solid #666;
  color: #666;
  text-align: center;

  font: 32px Arial, sans-serif;
}

.circle {
  border: 0.1em solid grey;
  border-radius: 100%;
  height: 1.5em;
  width: 1.5em;
  text-align: center;
  background: red;
}

.circle p {
  margin-top: 0.10em;
  font-size: 1em;
  font-weight: bold;
  font-family: sans-serif;
  color: grey;
  background: red;
}
</style>
